{
  "A1": "A1",
  "A2": "A2",
  "accents_and_special_characters": "Accents agus carachtair speisialta",
  "account": "Account",
  "activity": "Gníomhaíocht",
  "actor": "Aisteoir {{number}}",
  "actor_2": "Aisteoir 2",
  "actor_name": "Ainm an aisteora",
  "actor_voice": "Guth an aisteora",
  "add_alternatives": "Cuir roghanna eile leis",
  "add_another_reply": "Cuir freagra eile leis",
  "add_courses": "Cuir Cúrsaí leis",
  "add_answer": "Cuir Freagra leis",
  "add_image": "Cuir Íomhá leis",
  "add_image_desc": "Cuir íomhá le do chleachtadh!",
  "add_link": "Cuir Nasc leis",
  "add_link_desc": "Cuir nasc le do chleachtadh!",
  "all_steps_complete": "Gach céim críochnaithe",
  "alternative_versions": "Leaganacha eile",
  "archive_recording_error": "Bhí fadhb ann agus an taifeadadh á chartlannú",
  "assign": "Sann",
  "attach_file": "Ceangail comhad",
  "bot_not_found": "Comhrábot gan aimsiú",
  "bot_not_found_desc": "Níorbh fhéidir linn an comhrábot seo a aimsiú. Seans gur scriosadh é nó go bhfuil sé príobháideach.",
  "categories": "Catagóirí",
  "chart": "Cairt",
  "choose_length_of_roleplay": "Roghnaigh fad na cásanna",
  "clear": "Glan",
  "close_pdf": "Dún PDF",
  "comma_seperated_domains": "Fearainn scartha le camóga",
  "community": "Pobal",
  "datetime": "Dáta agus am",
  "days": "lá",
  "days_late": "{{count}} lá déanach",
  "discussion": "Plé",
  "download_error": "Bhí fadhb ann agus an comhad á íoslódáil",
  "editor_mode": "Mód eagarthóra",
  "email_notifications": "Fógraí ríomhphoist",
  "enter_linguistic_goal": "Iontráil sprioc teangeolaíoch",
  "add_new": "Cuir nua leis",
  "add_phrase": "Cuir frása leis",
  "add_phrase_desc": "Cuir frása nua {{language}} leis le foghlaim ag daoine",
  "add_phrases": "Cuir Frásaí leis",
  "add_phrases_to_enable_exercise": "Cuir frásaí leis chun aclaíocht a chumasú",
  "add_question": "Cuir Ceist leis",
  "add_question_desc": "Cuir ceist tuisceana, Is féidir go mbeidh iliomad freagraí cearta ar an gceist.",
  "add_review": "Cuir Athbhreithniú leis",
  "add_review_desc": "Comhroinn do chuid smaointe thíos",
  "add_script": "Cuir Script Leis",
  "add_section": "Cuir alt leis",
  "add_substitution": "Cuir ionadú leis",
  "add_substitution_desc": "Le hionadú, is féidir leat a fheiceáil dó go ndéantar 'cad' a leathnú go 'cad é' ina ionad - rud a ligeann duit smacht níos fearr a fháil ar an gcaoi a bhfreagraíonn tú do theachtaireacht an úsáideora!",
  "add_topic": "Cuir ábhar leis",
  "add_topic_desc": "Is iad na hábhair ná grúpálacha loighciúla truicear. Nuair a bhíonn úsáideoir i dtopaic, ní féidir leo ach truicear a bhaineann leis an ábhar sin a mheaitseáil.",
  "add_topic_to_section": "Cuir ábhar leis an gcuid {{sectionId}}",
  "add_trigger": "Cuir truicear leis",
  "add_trigger_desc": "Is éard is truicir ann líne téacs a úsáidtear chun teachtaireacht an úsáideora a mheaitseáil.",
  "add_variable": "Cuir athróg leis",
  "add_variable_desc": "Is píosaí faisnéise iad athróga chatbot a chuireann síos ar do chatbot. Le hathróga chatbot, is féidir linn freagraí a scríobh inar féidir leis an chatbot rud beag a insint dó féin faoin úsáideoir.",
  "add_voice": "Cuir guth leis",
  "all": "Ar fad",
  "all_topics_completed": "Gach ábhar críochnaithe",
  "alternatives": "Roghanna malartacha",
  "alternatives_desc": "Liosta focal nó frásaí is féidir a athúsáid i do chatbot.",
  "alternatives_name": "Ainm",
  "alternatives_value": "Liosta focal (scartha le camóga)",
  "answer": "Freagra",
  "new_answer_placeholder": "Scríobh d'fhreagra anseo",
  "answer_message_100": "Foirfe, Obair iontach",
  "answer_message_90": "Tá tú ag fáil ann, Coinnigh ort ag iarraidh",
  "answer_message_95": "Bhí sé sin gar, Tá tú beagnach ann",
  "answer_message_wrong": "Ní raibh sé sin ceart go leor",
  "attempt": "Iarract",
  "attempt_messages": "Iarracht Aclaíochta",
  "attempt_table": "Iarrachtaí",
  "auto_translate": "Auto translate",
  "auto_translate_phrase": "Uath-aistriú frása",
  "avg_pronunciation_score": "Avg Pronunciation Score",
  "average_pronunciation_score_tooltip": "Average pronunciation score is",
  "B1": "B1",
  "B2": "B2",
  "back": "Ar ais",
  "back_to_course": "Ar ais ar ndóigh",
  "blog": "Blag",
  "bot": "Chatbot",
  "bot-listen-and-speak": "Chatbot - Éist & Labhair",
  "all_modes": "Gach mód",
  "bot_information": "Eolas Chatbot",
  "bot_intro_message": "Teachtaireacht réamhrá chatbot",
  "bot_intro_message_helper_text": "Fág folamh más mian leat go dtosódh an mac léinn an comhrá.",
  "bot_name": "Ainm chatbot",
  "bot_reply": "Freagra Chatbot",
  "bot_settings": "Socruithe Chatbot",
  "bot_title": "Chatbot teideal",
  "bot_voice": "Guth chatbot",
  "bots": "Chatbots",
  "bots_not_found_desc": "Cruthaigh an chéad chatbot inniu",
  "bots_not_found_title": "Níor aimsíodh chatbots",
  "C1": "C1",
  "C2": "C2",
  "cancel": "Cealaigh",
  "card_A1": "A1",
  "card_A2": "A2",
  "card_B1": "B1",
  "card_B2": "B2",
  "card_C1": "C1",
  "card_C2": "C2",
  "change_app_colors": "Athraigh dathanna an aip",
  "change_language": "Athraigh teanga",
  "chatbot_exercise_desc": "Comhrá le chatbot chun comhrá faoi ábhar a insamhail",
  "chatbots": "Robots comhrá",
  "choose_avatar": "Roghnaigh Nuala",
  "choose_from_file": "Roghnaigh ón gcomhad",
  "classroom_code": "Cód seomra ranga",
  "classroom_code_label": "Iontráil cód an tseomra ranga",
  "classroom_code_not_valid": "Níl cód an tseomra ranga bailí",
  "classroom_created": "Seomra ranga cruthaithe",
  "classroom_deleted": "Scriosadh an seomra ranga",
  "classroom_information": "Eolas faoin seomra ranga",
  "classroom_name": "Ainm an tseomra ranga",
  "classroom_not_found": "Níor aimsíodh an seomra ranga",
  "classroom_not_found_desc": "B’fhéidir gur scriosadh an seomra ranga seo",
  "classroom_load_error": "Níorbh fhéidir an seomra ranga seo a lódáil",
  "classroom_load_error_desc": "Tharla earráid agus an seomra ranga seo á lódáil. Bain triail eile as.",
  "classroom_settings": "Socruithe seomra ranga",
  "classrooms": "Seomraí Ranga",
  "classrooms_not_found_desc": "Cruthaigh an chéad seomra ranga inniu",
  "classrooms_not_found_title": "Níor aimsíodh aon seomraí ranga",
  "collaborators": "Comhoibritheoirí",
  "color": "Dath",
  "community_templates": "Teimpléid Pobail",
  "completed": "Críochnaithe",
  "completed_icon": "Deilbhín críochnaithe",
  "completion": "Críochnú",
  "completions": "Críochnaithe",
  "confirmation": "Daingniú",
  "contact_form": "Foirm Teagmhála",
  "continue": "Leanúint ar aghaidh",
  "continue_exercise": "Leanúint ar aghaidh le Cleachtadh",
  "continue_learning": "Leanúint ar aghaidh ag foghlaim",
  "continue_teaching": "Lean ort ag múineadh",
  "copied": "Cóipeáladh",
  "copy_to_clipboard": "Cóipeáil chuig an gearrthaisce",
  "correct": "Ceart",
  "correct_answer": "Freagra Ceart",
  "correct_answer_percentage": "Correct Answer Percentage",
  "course": "Cúrsa",
  "course_code": "Cód an chúrsa",
  "course_code_label": "Iontráil cód an chúrsa",
  "course_code_not_valid": "Níl cód an chúrsa bailí",
  "course_created": "Cúrsa cruthaithe",
  "course_deleted": "Scriosadh an cúrsa",
  "course_information": "Eolas faoin gcúrsa",
  "course_name": "Ainm an chúrsa",
  "course_not_found": "Níor aimsíodh an cúrsa",
  "course_not_found_desc": "B’fhéidir gur scriosadh an cúrsa seo",
  "course_outline": "Imlíne an Chúrsa",
  "course_progress": "Dul chun cinn an Chúrsa",
  "course_settings": "Socruithe an chúrsa",
  "courses": "Cúrsaí",
  "courses_not_found_desc": "Cruthaigh an chéad chúrsa inniu",
  "courses_not_found_title": "Níor aimsíodh aon chúrsaí",
  "create": "Cruthaigh",
  "create_bot": "Cruthaigh chatbot",
  "create_classroom": "Cruthaigh Seomra Ranga",
  "create_course": "Cruthaigh Cúrsa",
  "create_course_section": "Cruthaigh roinn an chúrsa",
  "create_course_section_desc": "Is fútsa atá sé conas an cúrsa a struchtúrú, is iad na struchtúir shamplacha ná 'Bunleibhéal, Idirmheánach, Ardrang' nó 'Seachtain 1, Seachtain 2, Seachtain 3'",
  "create_topic": "Cruthaigh topaic",
  "created_courses": "Cúrsaí cruthaithe",
  "creation_visibility": "Is féidir ábhar poiblí a úsáid mar phointe tosaigh do chruthaithe oideachasóirí eile.",
  "creator": "Cruthaitheoir",
  "customization": "Saincheapadh",
  "dark_theme": "Téama Dorcha",
  "dark_theme_desc": "Casadh dromchlaí éadroma an leathanaigh dorcha, ag cruthú eispéireas atá oiriúnach don oíche.",
  "delete_bot": "Scrios Chatbot",
  "delete_bot_confirmation": "An bhfuil tú cinnte gur mhaith leat an chatbot seo a scriosadh?",
  "delete_classroom": "Scrios Seomra Ranga",
  "delete_classroom_confirmation": "An bhfuil tú cinnte gur mhaith leat an seomra ranga seo a scriosadh?",
  "delete_course": "Scrios cúrsa",
  "delete_course_confirmation": "An bhfuil tú cinnte gur mhaith leat an cúrsa seo a scriosadh?",
  "delete_phrase": "Scrios Frása",
  "delete_phrase_confirmation": "An bhfuil tú cinnte gur mhaith leat an frása seo a scriosadh?",
  "delete_review": "Scrios Athbhreithniú",
  "delete_review_confirmation": "An bhfuil tú cinnte gur mhaith leat d’athbhreithniú a scriosadh?",
  "delete_roleplay": "Scrios Rólghlacadh",
  "delete_roleplay_confirmation": "An bhfuil tú cinnte gur mhaith leat an rólghlacadh seo a scriosadh",
  "delete_section": "Scrios an chuid",
  "delete_section_confirmation": "An bhfuil tú cinnte gur mhaith leat an chuid seo a scriosadh?",
  "delete_topic": "Scrios ábhar",
  "delete_topic_confirmation": "An bhfuil tú cinnte gur mhaith leat an topaic seo a scriosadh?",
  "description": "Cur síos",
  "difficulty": "Deacracht",
  "difficulties": "Deacrachtaí",
  "disable": "Díchumasaithe",
  "disabled": "Faoi mhíchumas",
  "display": "Taispeáin",
  "display_classroom_code": "Display classroom code",
  "download_csv_file": "Íoslódáil",
  "drop_csv_file_or_click_to_upload": "Buail comhad CSV nó cliceáil chun uaslódáil.",
  "edit": "Cuir in Eagar",
  "edit_bot": "Cuir Chatbot in eagar",
  "edit_discussion": "Cuir díospóireacht in eagar",
  "edit_roleplay": "Cuir Rólghlacadh in eagar",
  "email": "Ríomhphost",
  "enable": "Cumasaigh",
  "enabled": "Cumasaithe",
  "enrolment_key": "Eochair rollaithe",
  "enrolment_key_not_valid": "Níl an eochair rollaithe bailí",
  "enter_private_key": "Iontráil Eochair Phríobháideach",
  "error_generating_discussion": "Bhí fadhb ann agus an plé á ghiniúint",
  "exercise": "Cleachtadh",
  "exercise_complete": "Cleachtadh Críochnaithe",
  "exercise_completed_icon": "{{name}} críochnaithe {{counter}} uair",
  "exercise_completion": "completed {{exercise}} exercise '{{id}}'",
  "exercise_in_progress": "started {{exercise}} exercise '{{id}}'",
  "exercise_progress_bar": "Exercise progress bar",
  "exercise_info": "Eolas faoi fheidhmiú",
  "exercise_no_longer_available": "Níl an cleachtadh seo ar fáil a thuilleadh",
  "exercises": "Cleachtaí",
  "exercises_completed": "Cleachtaí críochnaithe",
  "exercises_completed_icon": "{{name}} críochnaithe {{counter}} uair",
  "exit": "Scoir",
  "expand": "Leathnaigh",
  "fill_in_contact_form": "Líon an fhoirm thíos",
  "find_bot": "Faigh chatbot",
  "find_classroom": "Faigh Seomra Ranga",
  "find_course": "Faigh Cúrsa",
  "find_roleplay": "Faigh rólghlacadh",
  "finish": "Críochnaigh",
  "finish_exercise": "Críochnaigh Cleachtadh",
  "for_lang": "labhraím",
  "formatting_options": "Roghanna Formáidithe",
  "from": "Ó",
  "fullscreen": "Lánscáileán",
  "generate_definitions_info": "Gin sainmhínithe do na frásaí sa liosta seo.",
  "generating": "Á ghiniúint",
  "get_started": "Tosaigh",
  "go_back": "Dul ar ais",
  "go_back_to_topic": "Dul ar ais chuig Topaic",
  "go_to": "Go to",
  "go_to_settings": "Téigh go dtí na socruithe",
  "group_information_form_title": "Inis dúinn faoi do ghrúpa",
  "group_member_limit": "Uasteorainn ball an ghrúpa",
  "group_name": "Ainm an ghrúpa",
  "group_picture": "Pictiúr an ghrúpa",
  "group_subscription_form_title": "Socraigh síntiús an ghrúpa",
  "help": "Cabhair",
  "hidden": "Folaithe",
  "hide": "Folaigh",
  "hide_bot": "Folaigh chatbot",
  "hide_chatbots_exercise": "Folaigh chatbots",
  "hide_listening_exercise": "Folaigh cleachtadh éisteachta",
  "hide_menu": "Folaigh Roghchlár",
  "hide_options": "Folaigh roghanna",
  "hide_pronunciation_exercise": "Folaigh cleachtadh foghraíochta",
  "hide_roleplay": "Folaigh rólghlacadh",
  "hide_roleplays_exercise": "Folaigh rólghrúpaí",
  "hide_section": "Folaigh an chuid",
  "hide_topic": "Folaigh topaic",
  "hide_translation_exercise": "Folaigh cleachtadh aistriúcháin",
  "hide_word_bank": "Folaigh Banc Focal",
  "home": "Baile",
  "how_to_join_find_button": "Aimsigh an cnaipe {{button}} agus cliceáil air.",
  "how_to_join_get_ready": "Bí réidh le himirt.",
  "how_to_join_intro": "Chun páirt a ghlacadh sa chluiche, lean na céimeanna seo:",
  "how_to_join_open_classroom": "Oscail an seomra ranga {{classroom}} nó scan a chód QR thíos",
  "how_to_join_sign_in": "Sínigh isteach i do chuntas.",
  "how_to_join_title": "Conas Páirt a Ghlacadh sa Chluiche",
  "in_game": "Sa Chluiche",
  "in_progress": "Leanúint ar aghaidh ag imirt",
  "incorrect": "Mícheart",
  "insert_bold": "Cuir isteach trom",
  "insert_italic": "Cuir isteach iodálach é",
  "insert_link": "Cuir isteach nasc",
  "insert_photo": "Cuir isteach grianghraf",
  "instruction_message": "Treoracha",
  "join": "Bí páirteach",
  "join_classroom": "Bí ar an Seomra Ranga",
  "join_code_desc": "Féadfaidh mic léinn an cód thíos a úsáid chun páirt a ghlacadh",
  "join_course": "Bí ar an gCúrsa",
  "join_date": "Dáta Clárúcháin",
  "joined": "Cláraigh",
  "joined_classroom": "Seomra ranga ceangailte",
  "joined_course": "Cúrsa ceangailte",
  "language": "Teanga",
  "language_phrase": "{{language}} Frása",
  "language_translation": "{{language}} Aistriúchán",
  "learn": "Foghlaim",
  "learn_for_speakers_of": "{{learnLang}} do chainteoirí {{forLang}}",
  "learn_lang": "Ba mhaith liom foghlaim",
  "leave_classroom": "Fág Seomra Ranga",
  "leave_classroom_confirmation": "An bhfuil tú cinnte gur mhaith leat an seomra ranga seo a scriosadh?",
  "leave_course": "Fág Cúrsa",
  "leave_course_confirmation": "An bhfuil tú cinnte gur mhaith leat an cúrsa seo a fhágáil?",
  "left_classroom": "Seomra ranga ar chlé",
  "left_course": "Cúrsa ar chlé",
  "lets_begin": "Tosaíonn Lets",
  "library": "Leabharlann",
  "link_name": "Ainm Nasc",
  "link_name_helper_text": "Iontráil ainm taispeána do nasc",
  "link_value": "Nasc Url",
  "link_value_helper_text": "Iontráil an Url le haghaidh do nasc",
  "listen_to_this_phrase": "Éist leis an bhfrása {{language}} seo",
  "listener_dialog_desc": "Roghnaigh guth thíos chun an fuaimniú a chloisteáil",
  "listening": "Éisteacht",
  "listening_exercise_desc": "An féidir leat an méid atá á rá a phiocadh suas?",
  "load_more_events": "Luchtaigh níos mó imeachtaí",
  "loading": "Á lódáil",
  "loading_topics": "Ábhair á lódáil",
  "logout": "Logáil Amach",
  "manage_course": "Bainistigh Cúrsa",
  "members": "Mic léinn",
  "members_not_found": "Gan baill",
  "members_not_found_desc": "Ní bhfuarthas baill ar bith",
  "message": "Teachtaireacht",
  "method": "Modh",
  "missing_details": "Sonraí ar iarraidh",
  "more_definitions": "Tuilleadh sainmhínithe",
  "more_options": "Tuilleadh Roghanna",
  "more_translations": "Tuilleadh aistriúchán",
  "my_courses": "Mo chúrsaí",
  "name": "Ainm",
  "new": "Nua",
  "next": "Ar Aghaidh",
  "next_with_progress": "Ar Aghaidh ({current} as {total})",
  "no_activity_found": "Níor aimsíodh aon ghníomhaíocht",
  "no_chatbot_templates": "Níl aon teimpléad ar fáil",
  "no_courses_found": "Níor aimsíodh aon chúrsaí",
  "no_phrases": "Gan frásaí",
  "no_topics_available": "Níl aon ábhar ar fáil",
  "not_in_game": "Níl sa Chluiche",
  "nualang_templates": "Teimpléid",
  "nudge_add_family_name_field_desc": "Cuir do shloinne leis ionas gur féidir le do mhúinteoirí tú a aithint.",
  "nudge_add_family_name_profile_desc": "Cuir do shloinne le do phróifíl ionas gur féidir le do mhúinteoirí tú a aithint.",
  "nudge_add_family_name_title": "Cuir do shloinne leis",
  "on": "ar",
  "only_available_on_chrome": "Ar fáil ar Chrome amháin",
  "open_image_library": "Oscail an leabharlann íomhánna",
  "open_in_google_sheets": "Oscail i Google Sheets",
  "open_search_student_name_filters": "Open search student name filters",
  "optional": "Roghnach",
  "or_choose_from_one_of_the_following": "Nó roghnaigh ceann amháin díobh seo a leanas",
  "percentage_complete": "Percentage Complete",
  "perfect_click_finish_create_group": "Ar fheabhas! Cliceáil Críochnaigh chun do ghrúpa a chruthú.",
  "phrase": "Abairt",
  "phrase_group_game_in_progress_icon": "{{name}} ar siúl",
  "phrase_lists_error": "Bhí fadhb ann agus na liostaí frásaí á lódáil",
  "phrases": "Frásaí",
  "player": "imreoir",
  "players": "imreoirí",
  "plays": "Drámaí {{number}}",
  "please_select_a_textfield": "Roghnaigh réimse téacs, le do thoil",
  "popular_courses": "Cúrsaí is mó a úsáidtear",
  "preview": "Réamhamharc",
  "preview_pdf": "Réamhamharc PDF",
  "previous": "Roimhe seo",
  "print": "Priontáil",
  "private": "Príobháideach",
  "problem": "Bhí fadhb ann",
  "problem_creating": "Bhí fadhb ag cruthú",
  "problem_deleting": "Bhí fadhb ann scriosadh",
  "problem_getting_reply": "Bhí fadhb ann freagra a fháil",
  "problem_loading": "Bhí fadhb ag luchtú",
  "problem_sending_contact_form": "Fadhb teagmhála a sheoladh",
  "profile": "Próifíl",
  "profiles": "Próifílí",
  "progress_icon": "Deilbhín dul chun cinn",
  "pronounce_this_phrase": "Ainmnigh an frása seo",
  "pronunciation": "Fuaimniú",
  "pronunciation_exercise_desc": "Cleachtaigh frásaí fuaimnithe",
  "public": "Poiblí",
  "question": "Ceist",
  "new_question_placeholder": "Scríobh do cheist anseo",
  "questions": "Ceisteanna",
  "quit": "Scoir",
  "recommended": "Molta",
  "record_message": "Teachtaireacht Taifead",
  "record_unsupported": "Ní thacaítear le taifeadadh sa bhrabhsálaí seo",
  "records": "Taifid",
  "redo_action": "Athdhéan",
  "refresh": "Athnuaigh",
  "remove": "Bain",
  "remove_bot": "Bain Chatbot",
  "remove_card": "Remove Card",
  "remove_roleplay": "Bain Roleplay",
  "remove_classroom_member": "Remove Classroom Student",
  "remove_classroom_member_confirmation": "Are you sure you want to remove this student from your classroom",
  "remove_member": "Remove Student",
  "member_removed_from_classroom": "Student removed from classroom",
  "reply": "Freagra",
  "reply_options": "Freagraí roghanna",
  "reply_options_are_disabled": "Tá roghanna freagartha díchumasaithe",
  "reply_options_desc": "Lig do mhic léinn an freagra ceart a roghnú ó liosta roghanna",
  "report_views": "Views",
  "required_for_private_classrooms": "Riachtanach do sheomraí ranga príobháideacha",
  "required_for_private_courses": "Ag teastáil le haghaidh cúrsaí príobháideacha",
  "reset": "athshocrú",
  "restart_exercise": "Atosaigh Cleachtadh",
  "result": "Toradh",
  "retry": "Bain triail eile as",
  "return_to_course": "Fill ar an gCúrsa",
  "review_content": "Ábhar Athbhreithnithe",
  "review_title": "Teideal an Athbhreithnithe",
  "reviews": "Léirmheasanna",
  "reviews_not_found": "Gan aon léirmheasanna",
  "reviews_not_found_desc": "Ní bhfuarthas aon athbhreithnithe",
  "roleplay": "Rólghlacadh",
  "roleplay_exercise_desc": "Samhlaigh agus freagair ceisteanna ar chomhráite idir beirt",
  "roleplay_not_found": "Cás gan aimsiú",
  "roleplay_not_found_desc": "Níorbh fhéidir linn an cás seo a aimsiú. Seans gur scriosadh é nó go bhfuil sé príobháideach.",
  "roleplays_not_found_desc": "Bain triail as do pharaiméadair chuardaigh a athrú",
  "roleplay_information": "Eolas faoi Rólghlacadh",
  "roleplay_name": "Ainm rólghlacadh",
  "roleplay_settings": "Socruithe Rólghlacadh",
  "roleplays": "Róilphoist",
  "save_changes": "Sabháil na hathruithe",
  "save_definitions_error": "Bhí fadhb ann agus na sainmhínithe á sábháil",
  "save_progress": "Sábháil Dul Chun Cinn",
  "scenarios": "Cásanna",
  "schedule": "Sceideal",
  "script_not_found": "Script gan aimsiú",
  "script_not_found_desc": "Níorbh fhéidir linn an script seo a aimsiú. Seans gur scriosadh í nó go bhfuil sí príobháideach.",
  "search_images": "Cuardaigh íomhánna",
  "see_more_pronunciations": "Féach ar thuilleadh fuaimnithe",
  "send": "Seol",
  "show_phrase_list": "Taispeáin an liosta frásaí",
  "show_progress": "Taispeáin Dul Chun Cinn",
  "script": "Script",
  "search": "Search",
  "search_for_student": "Cuardach a dhéanamh ar mhac léinn",
  "section": "Alt",
  "section_name": "Ainm na roinne",
  "sections_not_found": "Níor aimsíodh aon ailt",
  "sections_not_found_desc": "",
  "select_a_template": "Roghnaigh Teimpléad",
  "select_file": "Roghnaigh comhad",
  "select_file_desc": "Buail comhad anseo nó cliceáil chun do mheaisín a bhrabhsáil",
  "select_files": "Roghnaigh comhaid",
  "select_the_from_date": "Roghnaigh an Ó dáta",
  "select_the_to_date": "Roghnaigh an Go Dáta",
  "settings": "Socruithe",
  "share": "Comhroinn",
  "share_via": "Comhroinn trí",
  "show_bot": "Taispeáin chatbot",
  "show_chatbots_exercise": "Taispeáin chatbots",
  "show_listening_exercise": "Taispeáin cleachtadh éisteachta",
  "show_menu": "Taispeáin Roghchlár",
  "show_options": "Taispeáin roghanna",
  "show_pronunciation_exercise": "Taispeáin cleachtadh foghraíochta",
  "show_roleplay": "Taispeáin rólghlacadh",
  "show_roleplays_exercise": "Taispeáin rólghrúpaí",
  "show_section": "Taispeáin an chuid",
  "show_topic": "Taispeáin topaic",
  "show_translation_exercise": "Taispeáin cleachtadh aistriúcháin",
  "skip": "Scipeáil",
  "skip_copy_topic": "Scipeáil",
  "speakers_of": "Cainteoirí As",
  "start": "Tosaigh",
  "start_course": "Cúrsa Tosaigh",
  "stop": "Stop",
  "stop_recording": "Stop Taifeadadh",
  "student_instructions": "Treoracha do Mhic Léinn",
  "student_instructions_placeholder": "Treoracha do Mhic Léinn:\nIs féidir leat do theachtaireacht formáidithe treoracha a chur isteach anseo \n\ne.g. \"Fáilte go dtí an chatbot, is féidir leat tosú trí chlóscríobh isteach Dia duit \"",
  "student_limit": "Uasteorainn daltaí",
  "subject": "Ábhar",
  "submit": "Cuir isteach",
  "submitting": "Á chur isteach",
  "subscription": "Síntiús",
  "subscription_period_end": "Deireadh thréimhse an tsíntiúis",
  "subscription_status": "Stádas an tsíntiúis",
  "substitution_desc": "Déan athruithe ar theachtaireacht an úsáideora sula ndéantar triggers a sheiceáil.",
  "substitution_name": "Téacs bunaidh",
  "substitution_name_helper_text": "An téacs bunaidh a d’fhéadfadh a bheith le feiceáil i dteachtaireacht an úsáideora",
  "substitution_value": "Téacs ionadaíochta",
  "substitution_value_helper_text": "Níor cheart go mbeadh aon siombailí nó poncaíocht speisialta ann, agus ba cheart iad a ísliú freisin",
  "substitutions": "Ionadaíocht",
  "table": "Tábla",
  "thank_you_for_submitting": "Go raibh maith agat as cur isteach, rachaimid i dteagmháil leat a luaithe is féidir. Ag dul ar ais go dtí an leathanach baile",
  "the_default_topic_is_random": "Tá an topaic randamach randamach",
  "to": "Chun",
  "toggle_theme": "Téama éadrom / dorcha a thógáil",
  "toggle_light": "Toggle light theme",
  "toggle_dark": "Toggle dark theme",
  "topic": "Ábhar",
  "topic_code": "Cód ábhair",
  "topic_desc": "Nuair a bhíonn úsáideoir i dtopaic, ní féidir leo ach truicear a bhaineann leis an ábhar sin a mheaitseáil.",
  "topic_image": "Íomhá an ábhair",
  "topic_information": "Eolas Ábhar",
  "topic_name": "Ainm an ábhair",
  "topic_not_found": "Níor aimsíodh an t-ábhar",
  "topic_not_found_desc": "B’fhéidir gur scriosadh an topaic seo",
  "topics": "Ábhair",
  "translate": "Aistrigh",
  "translate_is_disabled": "Tá Translate díchumasaithe",
  "translate_this_phrase": "Aistrigh an frása seo",
  "translation": "Aistriúchán",
  "translation_exercise_desc": "Déan tástáil ar do scileanna teanga trí fhrásaí a aistriú",
  "translations": "Aistriúcháin",
  "trigger_value": "Téacs truicear",
  "trigger_value_helper_text": "Níor cheart go mbeadh aon siombailí nó poncaíocht speisialta ann, agus ba cheart iad a ísliú freisin",
  "triggers": "Triggers",
  "triggers_desc": "Is éard is truicir ann líne téacs a úsáidtear chun teachtaireacht an úsáideora a mheaitseáil.",
  "type": "Cineál",
  "unarchive": "Bain as an gcartlann",
  "undo_action": "Cealaigh",
  "update": "Nuashonrú",
  "update_image": "Nuashonraigh an íomhá",
  "update_link": "Nuashonraigh an nasc",
  "update_phrase": "Frása a Nuashonrú",
  "update_phrase_desc": "Déan athruithe ar an bhfrása seo atá ann",
  "update_picture": "Nuashonraigh Pictiúr",
  "update_question": "Ceist Nuashonraithe",
  "update_question_desc": "Cuir ceist tuisceana, Is féidir go mbeidh iliomad freagraí cearta ar an gceist.",
  "update_recording_error": "Bhí fadhb ann agus an taifeadadh á nuashonrú",
  "update_review": "Athbhreithniú ar Nuashonrú",
  "update_review_desc": "Tuairisc ar an Athbhreithniú ar Nuashonrú",
  "update_section": "Rannóg Nuashonraithe",
  "update_section_desc": "Is fútsa atá sé conas an cúrsa a struchtúrú, is iad na struchtúir shamplacha ná 'Bunleibhéal, Idirmheánach, Ardrang' nó 'Seachtain 1, Seachtain 2, Seachtain 3'",
  "update_substitution": "Ionadaíocht a nuashonrú",
  "update_topic": "Ábhar a nuashonrú",
  "update_trigger": "Nuashonraigh truicir",
  "update_variable": "Athróg a nuashonrú",
  "upgrade": "Uasghrádaigh",
  "upload_phrases": "Frásaí a Uaslódáil",
  "upload_phrases_desc": "Cruthaigh agus uaslódáil comhad csv cosúil leis an sampla thíos.",
  "upload_phrases_example_phrase_1": "dia duit",
  "upload_phrases_example_phrase_2": "slán",
  "upload_phrases_example_phrase_3": "is mise",
  "upload_phrases_example_definition_1": "Focal a úsáidtear chun beannú do dhuine",
  "upload_phrases_example_definition_2": "Focal a úsáidtear nuair atá tú ag imeacht",
  "upload_phrases_example_definition_3": "Frása a úsáidtear chun d'ainm a insint do dhuine",
  "upload_script": "Script Uaslódáil",
  "upload_script_desc": "Uaslódáil script rólghlacadh le comhad csv tríd an bhformáid a thaispeántar thíos a úsáid",
  "use_keyboard": "Úsáid Méarchláir",
  "use_word_bank": "Úsáid Banc Focal",
  "user_message": "Teachtaireacht Úsáideora",
  "user_updated": "Úsáideoir nuashonraithe",
  "variable_desc": "Píosaí faisnéise is féidir a úsáid i do chatbot.",
  "variable_name": "Ainm inathraithe",
  "variable_value": "Luach inathraithe",
  "variables": "Athróga",
  "vars": "Athróga",
  "view_activity": "Féach ar Ghníomhaíocht",
  "view_instruction_message": "Féach ar threoracha",
  "view_outline": "Féach ar Imlíne",
  "view_progress": "Féach ar an Dul Chun Cinn",
  "visibility": "Infheictheacht",
  "visit_learning_site": "Tabhair cuairt ar an Learning Site",
  "voice_speed_disabled": "Níl luas an ghutha ar fáil don ghuth seo",
  "weekly_progress": "Dul chun cinn seachtainiúil",
  "what_do_you_hear": "Cad a chloiseann tú?",
  "answer_method": "Modh Freagra",
  "answers": "Freagraí",
  "attempt_info": "Iarracht Eolas",
  "bot_outputs": "Aschuir Chatbot",
  "creator_instructions": "Treoracha do Mhúinteoirí",
  "creator_instructions_placeholder": "Is féidir leat teachtaireacht treorach formáidithe a chur le comhoibritheoir cúrsa anseo, e.g. Fáilte go dtí an chatbot, Seo conas a shaincheapadh do do mhic léinn ...",
  "date": "Dáta",
  "fri": "Aoine",
  "listener": "Éisteoir",
  "mon": "Luan",
  "new_bots": "Chatbots Nua",
  "new_courses": "Cúrsaí Nua",
  "new_roleplays": "Róilphleananna Nua",
  "no_results_found": "Ní bhfuarthas torthaí",
  "option": "Rogha",
  "play_again": "Imir arís",
  "role_played": "Ról Imeartha",
  "sat": "Satharn",
  "show_word_bank": "Taispeáin Banc Focal",
  "skipped": "Gan bacadh",
  "speak": "Labhair",
  "sun": "Grian",
  "text": "Téacs",
  "thu": "Thu",
  "time": "Am",
  "time_spent": "Am a Chaitear",
  "tue": "Máirt",
  "view_report": "Féach an Tuarascáil",
  "voice": "Guth",
  "wed": "Céad",
  "word_bank": "Bainc focal",
  "teach": "Múin",
  "active_now": "Gníomhach anois",
  "manage_classroom": "Bainistigh Seomra Ranga",
  "must_question_least_correct_answer": "Caithfidh gur ceist í agus freagra ceart amháin ar a laghad.",
  "enter_name_your_voice_clip": "Iontráil ainm do ghearrthóg gutha?",
  "my_unnamed_clip": "Mo ghearrthóg gan ainm",
  "are_you_sure": "An bhfuil tú cinnte?",
  "is_already_created_variable_overwrite": "athróg cruthaithe cheana féin, an bhfuil tú ag iarraidh é a fhorscríobh?",
  "is_already_created_substitution_overwrite": "ionadach cruthaithe cheana féin, an bhfuil tú ag iarraidh é a fhorscríobh?",
  "is_already_created_alternative_overwrite": "is rogha eile cruthaithe cheana féin, an bhfuil tú ag iarraidh é a fhorscríobh?",
  "is_already_created_topic_overwrite": "is ábhar cruthaithe é cheana féin, an bhfuil tú ag iarraidh é a fhorscríobh?",
  "bring_your_bot_picture_name": "Tabhair do chatbot chun beatha trí phictiúr agus ainm a thabhairt dó",
  "perfect_click_finish_create_bot": "Foirfe, Cliceáil bailchríoch chun do chatbot nua a chruthú",
  "lets_start_with_some_information_about_your_bot": "Tosaímid le roinnt faisnéise faoi do chatbot",
  "lets_start_some_information_about_classroom": "Tosaímid le roinnt faisnéise faoi do sheomra ranga",
  "the_language_classroom_teach": "An teanga a mhúinfidh an seomra ranga seo",
  "the_language_students_classroom_speak": "An teanga a labhraíonn mic léinn an tseomra ranga seo",
  "limit_access_classroom_visibility_private_including_enrolment_key": "Teorainn a chur le rochtain ar do sheomra ranga trí infheictheacht a shocrú go príobháideach agus eochair rollaithe a áireamh",
  "add_collaborators": "Cuir comhoibritheoirí leis",
  "perfect_click_finish_create_classroom": "Foirfe, Cliceáil bailchríoch chun do sheomra ranga nua a chruthú",
  "perfect_click_finish_create_course": "Foirfe, Cliceáil bailchríoch chun do chúrsa nua a chruthú",
  "lets_start_information_about_course": "Tosaímid le roinnt faisnéise faoi do chúrsa",
  "the_language_course_teach": "An teanga a mhúinfidh an cúrsa seo",
  "the_language_students_course_speak": "An teanga a labhraíonn mic léinn an chúrsa seo",
  "limit_access_course_setting_visibility_private_including_enrolment_key": "Teorainn a chur le rochtain ar do chúrsa trí infheictheacht a shocrú go príobháideach agus eochair rollaithe a áireamh",
  "selected": "Roghnaithe",
  "perfect_click_finish_create_roleplay": "Foirfe, Cliceáil bailchríoch chun do rólghlacadh nua a chruthú",
  "lets_start_with_information_about_roleplay": "Tosaímid le roinnt faisnéise faoi do rólghlacadh",
  "invite": "Tabhair cuireadh",
  "topic_settings": "Socruithe Ábhar",
  "topic_title": "Teideal Ábhar",
  "unanswered_table": "Gan freagra",
  "create_roleplay": "Cruthaigh rólghlacadh",
  "roleplays_not_found_title": "Níor aimsíodh rólghrúpaí",
  "play": "Imirt",
  "delete": "Scriosadh",
  "delete_picture": "Scrios Pictiúr",
  "use_wordbank_if_stuck": "Úsáid an banc focal má tá cabhair uait",
  "play_bot_error": "Úps! Tharla fadhb leis an chatbot, bain triail eile as",
  "bot_editor_preview_error": "Tharla earráid. Tabhair cuairt ar https://nualang.com/guides/create-a-bot chun treoir a fháil ar chatbot a chruthú",
  "manage_courses": "Bainistigh Cúrsaí",
  "refresh_courses": "Athnuaigh Cúrsaí",
  "customize_appearance_of_course": "Saincheap cuma an chúrsa",
  "customize_appearance_of_classroom": "Saincheap cuma an tseomra ranga",
  "customize_appearance_of_topic": "Customize the appearance of the topic",
  "create_duplicate": "Cruthaigh Dúblach",
  "section_visibility": "Infheictheacht na Rannóige",
  "choose_a_language": "Roghnaigh teanga",
  "play_bot": "Seinn chatbot",
  "lets_find_a_template": "Faighimid teimpléad!",
  "search_by_difficulty": "Cuardaigh de réir deacrachta",
  "search_using_keywords": "Cuardaigh ag úsáid eochairfhocail",
  "select_a_nualang_template": "Roghnaigh teimpléad Nualang",
  "select_a_nualang_template_desc": "Teimpléid a thóg foireann Nualang chun cabhrú leat tosú.",
  "or_select_a_community_template": "Nó roghnaigh teimpléad pobail",
  "or_select_a_community_template_desc": "Tógann múinteoirí ar fud an domhain teimpléid phobail.",
  "dashboard_welcome": "Fáilte, {{name}}!",
  "dashboard_welcome_desc": "Faigh familar leis an Painéal na nIonstraimí, seo roinnt bealaí chun tosú.",
  "enter_course_code": "Iontráil cód cúrsa",
  "enter_course_code_desc": "Má tá cód cúrsa agat, iontráil é anseo.",
  "enter_classroom_code": "Iontráil cód seomra ranga",
  "enter_classroom_code_desc": "Má tá cód seomra ranga agat, iontráil é anseo.",
  "search_nualang": "Déan iniúchadh ar Nualang",
  "search_nualang_desc": "Tá pobal méadaitheach de mhúinteoirí ar aon intinn ag forbairt comhráite lenár Nualas agus mar sin tá rud éigin nua le foghlaim i gcónaí.",
  "create_nualang": "Cruthaigh do chuid féin",
  "create_nualang_desc": "Cruthaigh comhráite agus ceachtanna teanga.",
  "roleplay_editor_welcome": "Ag tosú leis an Eagarthóir Rólghlacadh",
  "roleplay_editor_options": "Roghnaigh rogha",
  "roleplay_editor_options_desc": "Roghnaigh Nuala chun líne nua a chur leis, nó cuir ceist tuisceana leis.",
  "roleplay_editor_share": "Comhroinn rólghlacadh",
  "roleplay_editor_play": "Seinn rólghlacadh",
  "bot_editor_welcome": "Ag tosú leis an Eagarthóir Chatbot",
  "bot_editor_sidebar": "Barra taobh an eagarthóra",
  "bot_editor_sidebar_desc": "Is é an barra taobh an mbeidh tú in ann athruithe a dhéanamh ar do chatbot.",
  "bot_editor_flow_chart": "Sreabhadh chatbot",
  "bot_editor_flow_chart_desc": "Taispeánann an sreabhadh chatbot forbhreathnú ar do chatbot agus tugann sé réamhamharc ar an gcuma a bheidh ar gach teachtaireacht.",
  "bot_editor_share": "Comhroinn chatbot",
  "bot_editor_play": "Seinn chatbot",
  "play_roleplay": "Seinn Rólghlacadh",
  "delete_script_item": "Scrios Mír ón Script",
  "delete_script_item_confirmation": "An bhfuil tú cinnte gur mhaith leat an mhír seo a scriosadh ón script?",
  "add_message": "Cuir teachtaireacht leis",
  "resources": "Acmhainní",
  "contact": "Déan teagmháil",
  "sign_in": "Logáil isteach",
  "sign_up": "Clarú",
  "faqs": "Ceisteanna Coitianta",
  "guides": "Ranganna Teagaisc",
  "back_to_app": "Ar ais go App",
  "notes": "Nótaí",
  "notes_placeholder": "Iontráil nótaí anseo",
  "get_in_touch": "Téigh i dteagmháil",
  "get_in_touch_desc": "An bhfuil ceisteanna nó aiseolas agat? Seol teachtaireacht chugainn.",
  "avatar_generator": "Gineadóir Avatar",
  "avatar_generator_desc": "Déan do avatar pearsanta féin",
  "upload_image": "Íomhá Uaslódáil",
  "upload_image_desc": "Tarraing agus scaoil íomhá ó do ríomhaire",
  "random": "Randamach",
  "done": "Arna dhéanamh",
  "file_size_exceeded": "Íomhá ró-mhór! Uaslódáil íomhá níos lú ná ",
  "image_selection_failed": "Níorbh fhéidir an íomhá sin a lódú. Bain triail as íomhá eile nó uaslódáil do cheann féin.",
  "remove_course": "Bain Cúrsa",
  "courses_joined": "Cúrsaí isteach",
  "classroom_courses_not_found_title": "Níl cúrsaí fós",
  "classroom_courses_not_found_desc": "Níl aon chúrsaí sa seomra ranga seo go fóill.",
  "in_progress_activity": "Ar siúl",
  "bot_exercise_welcome": "Getting started with the Chatbot Exercise",
  "bot_exercise_restart": "Restart the chatbot!",
  "bot_exercise_keyboard_input": "Type it!",
  "bot_exercise_keyboard_input_desc": "Use the keyboard to type a message. If you need help with special characters or want to add an emoji try our helpful buttons.",
  "bot_exercise_voice_input": "Speak it!",
  "bot_exercise_voice_input_desc": "Click the microphone to use your voice and practice your pronunciation.",
  "bot_exercise_send_message": "Send it!",
  "bot_exercise_send_message_desc": "Send a message to the chatbot and get the conversation started.",
  "bot_exercise_audio_only_mic": "Speak it!",
  "bot_exercise_audio_only_mic_desc": "Tap the microphone to start. After that, just speak naturally — Nuala will listen and respond automatically for the rest of the conversation.",
  "roleplay_exercise_welcome": "Getting started with the Roleplay Exercise",
  "roleplay_exercise_read_script": "Learn your lines!",
  "roleplay_exercise_read_script_desc": "Read the conversation and listen to how the words are pronounced.",
  "roleplay_exercise_select_an_actor": "Choose your role!",
  "roleplay_exercise_select_an_actor_desc": "Select the role you would like to play.",
  "roleplay_exercise_start": "Act it out!",
  "roleplay_exercise_start_desc": "Click start and use your keyboard or voice to act out the role you have chosen.",
  "listening_exercise_welcome": "Getting started with the Listening Exercise",
  "listening_exercise_speak": "Listen to the phrase!",
  "listening_exercise_speak_desc": "Click to listen to how the phrase is pronounced.",
  "listening_exercise_voice_options": "Hear a different voice!",
  "listening_exercise_voice_options_desc": "Listen to the phrase being said in different voices.",
  "listening_exercise_keyboard_input": "Type the answer!",
  "listening_exercise_keyboard_input_desc": "Use the keyboard to type the phrase you hear.",
  "listening_exercise_word_bank": "Need help?",
  "listening_exercise_word_bank_desc": "Use the word bank to select the correct answer.",
  "translation_exercise_welcome": "Getting started with the Translation Exercise",
  "translation_exercise_speak": "Listen to the phrase!",
  "translation_exercise_speak_desc": "Click to listen to how the phrase is pronounced.",
  "translation_exercise_read": "Read the phrase!",
  "translation_exercise_read_desc": "Read the phrase to be translated.",
  "translation_exercise_keyboard_input": "Type the answer!",
  "translation_exercise_keyboard_input_desc": "Use the keyboard to type the translation.",
  "translation_exercise_word_bank": "Need help?",
  "translation_exercise_word_bank_desc": "Use the word bank to select the correct answer.",
  "pronunciation_exercise_welcome": "Getting started with the Pronunciation Exercise",
  "pronunciation_exercise_speak": "Listen to the phrase!",
  "pronunciation_exercise_speak_desc": "Click to listen to how the phrase is pronounced.",
  "pronunciation_exercise_read": "Read the phrase!",
  "pronunciation_exercise_read_desc": "Read the phrase to be pronounced.",
  "pronunciation_exercise_voice_input": "Pronounce the phrase!",
  "pronunciation_exercise_voice_input_desc": "Click the microphone to use your voice and practice your pronunciation.",
  "exercise_share": "Share with others!",
  "exercise_mute": "Mute the sound!",
  "exercise_skip": "Skip!",
  "exercise_skip_desc": "Move to the next phrase, you will be able to try again at the end.",
  "exercise_restart": "Restart!",
  "what_would_you_like_to_do": "What would you like to do?",
  "i_want_to_learn": "I want to learn...",
  "i_want_to_teach": "I want to teach...",
  "add_alternative_version": "Add alternative version",
  "language_translation_helper_text": "Press enter / return key to add translation.",
  "change_roles": "Change roles?",
  "write_your_feedback_here": "Scríobh do chuid aiseolais anseo",
  "yes": "Tá",
  "you_are_human_check": "Deimhnigh gur duine tú, le do thoil",
  "you_will_lose_your_progress_on_this_exercise": "You will lose your progress on this exercise.",
  "confirm": "Confirm",
  "general": "General",
  "shuffle_phrases": "Frásaí Shuffle",
  "shuffle_phrases_desc": "Déan na ceisteanna oird a randamú a chuirtear sna cleachtaí.",
  "errors": "Earráidí",
  "missing_translation": "Aistriúchán ar iarraidh",
  "missing_phrase": "Frása ar iarraidh",
  "invalid_image_domain": "Caithfidh URL na híomhá a bheith ó fhearann ceadaithe Nualang",
  "row": "Sraith",
  "no_valid_type": "Caithfidh an cineál a bheith 'actor' nó 'question'",
  "no_actor_text": "Gan téacs don aisteoir",
  "no_actor_number": "Caithfidh uimhir a bheith ag an aisteoir ag an deireadh e.g. actor1, actor2",
  "no_question": "Sin ceist",
  "no_answers_provided": "Níor soláthraíodh freagraí",
  "no_correct_answer_provided": "Gan aon soláthróir freagraí cearta",
  "no_answers": "Gan freagraí",
  "duplicate_topic": "Ábhar Dúblach",
  "normal_mode": "Mód Gnáth",
  "spreadsheet_mode": "Mód Scarbhileog",
  "image": "Íomha",
  "delete_selected_row": "Scrios an tsraith roghnaithe",
  "crop_image": "Íomhá Barr",
  "crop": "Barraí",
  "zoom": "Súmáil",
  "rotate": "Rothlú",
  "hide_preview": "Folaigh Réamhamharc",
  "show_preview": "Taispeáin Réamhamharc",
  "try_again": "Déan iarracht arís",
  "confidence_score": "Léiríonn an céatadán muiníne an dóchúlacht gur aithníodh na focail aonair i gceart.",
  "subscription_plan_teach": "Teach Plan",
  "subscription_plan_teacher_pro": "Teacher PRO",
  "subscription_plan_basic": "Teacher Basic",
  "subscription_plan": "Subscription Plan",
  "subscription_status_trialing": "Free Trial",
  "subscription_status_active": "Active",
  "subscription_status_canceled": "Canceled",
  "subscription_status_undefined": "Free",
  "status": "Status",
  "upgrade_plan": "Upgrade Plan",
  "manage_plan": "Manage Plan",
  "cancel_plan": "Cancel Plan",
  "your_plan": "Your Plan",
  "plan_cost": "Plan Cost",
  "next_billing_date": "Current Period End",
  "free": "Free",
  "payment_method": "Payment Method",
  "pricing_page_title": "Choose your plan",
  "pricing_page_subtitle": "Pricing plans for teachers, schools and districts.",
  "pricing_page_testimonials_title": "What Teachers are saying",
  "compare_plans": "Compare Plans",
  "features": "Features",
  "upgrade_submit": "Upgrade",
  "upgrade_subscription_desc": "To access this feature you need to upgrade your account. Click Upgrade to be taken to the pricing page.",
  "upgrade_plan_explanation": "To access this feature you need to upgrade your account.",
  "upgrade_subscription_student": "This feature is available to teachers only.",
  "public_visibility_disabled_wayside": "Is é Wayside Publishing a bhainistíonn seomraí ranga agus caithfidh siad fanacht príobháideach.",
  "public_visibility_disabled_loading": "Táimid fós ag seiceáil do shíntiúis. Athnuaigh an leathanach mura dtagann aon athrú air seo.",
  "public_visibility_disabled_trial": "Níl seomraí ranga poiblí ar fáil le linn trialach saor in aisce. Uasghrádaigh go plean íoctha chun an seomra ranga seo a dhéanamh poiblí.",
  "creator_not_subscribed": "This content is not joinable as the creator is not currently subscribed.",
  "first_name": "First Name",
  "last_name": "Last Name",
  "role": "Role",
  "school_name": "School Name",
  "school_district": "School District",
  "city": "City",
  "state": "State",
  "send_message": "Send Message",
  "sign_me_up": "Sign me up!",
  "free_trial": "FREE Trial",
  "interactive_demo": "Interactive Demo",
  "news_and_updates": "News and Updates",
  "teacher": "Teacher",
  "principal": "Principal",
  "tutor": "Tutor",
  "parent": "Parent",
  "student": "Student",
  "other": "Other",
  "none": "None",
  "group_subscription_plans": "Group Subscription Plans",
  "group_plan": "Group Plan",
  "leave_group": "Leave Group",
  "joined_subscription": "Joined subscription",
  "joined_subscription_desc": "Welcome to the {{groupName}} group subscription, you are now using Teacher PRO!",
  "unable_to_join_subscription": "Unable to join subscription",
  "unable_to_join_subscription_desc": "There was an issue joining subscription, please try again later.",
  "unable_to_join_subscription_invalid_email_desc": "You cannot join this group without having one of the allowed email domains: {{allowedDomains}}",
  "unable_to_join_subscription_limit_reached_desc": "'{{groupName}}' has reached it's student limit, contact the group admin to increase the limit.",
  "moderated_image_dialog": "Nualang detected an image that was inappropriate, unwanted, or offensive and blocked it to provide a safer user experience. Please try a different image.",
  "moderate_title": "Image Blocked",
  "recommended_courses": "Recommended Courses",
  "subscription_status_trialing_expired": "Free Trial Expired",
  "no_public_content_created": "No public content created",
  "add_tag": "Press enter / return key to add a tag",
  "add_collaborator_tag": "Press enter / return key to add a collaborator",
  "add_to_classroom": "Add to classrooms",
  "add_to_classroom_desc": "Add '{{courseName}}' to {{classroomNames}}.",
  "change_voice_speed": "Change the voice speed!",
  "extra_fast": "Super speed",
  "fast": "Very fast talker",
  "medium": "Normal speed",
  "slow": "Slow it down a bit",
  "extra_slow": "One word at a time",
  "card_ALL": "All",
  "join_classroom_to_access": "Join classroom to access",
  "join_course_to_access": "Join course to access",
  "confidence": "Confidence",
  "teach_lang": "I want to teach",
  "write_feedback": "Write Feedback",
  "allowed_domains": "Allowed school domains (optional)",
  "add_allowed_domains_desc": "Restrict access based on school domain e.g 'schooldomain.com'",
  "send_feedback": "Send Feedback",
  "add_feedback": "Add Feedback",
  "feedback_content": "Feedback Content",
  "report_problem": "Report problem",
  "report_problem_input_label": "Problem description",
  "update_feedback": "Update Feedback",
  "student_completes_exercise": "A student completes an exercise",
  "delete_feedback_confirmation": "Are you sure you want to delete this feedback?",
  "delete_feedback": "Delete Feedback",
  "updates_to_our_terms_of_service": "Updates to our Terms of Service",
  "email_me_when": "Email me when:",
  "new_classroom": "New Classroom",
  "student_progress": "Student Progress",
  "view_course": "View Course",
  "view_section": "View Section",
  "classroom_members_not_found_title": "No students yet",
  "classroom_members_not_found_desc": "This classroom does not have any students yet.",
  "open_topic": "Open Topic",
  "click_to_speak": "click to speak",
  "click_to_stop": "click to stop",
  "listening_indicator": "Listening ...",
  "save_recording_to_report": "Save recording to report",
  "no_voice_recording_saved": "Voice recording was not saved",
  "classrooms_not_created": "No classrooms created",
  "select_a_classroom": "Select a classroom",
  "voice_attempt": "Voice attempt",
  "upload_variables": "Upload variables",
  "next_game": "Next Game",
  "roleplay_games": "Roleplay Games",
  "roleplay_games_description": "Click on one of the cards below to play a specific game",
  "choose_game_mode": "Choose a game mode",
  "story": "Story",
  "story_description": "Listen to the conversation between the characters and answer questions to test your understanding.",
  "fill_in_blanks": "Fill in the blanks",
  "fill_in_blanks_description": "Can you correctly identify what's missing?",
  "fill_in_the_blanks": "Fill in the blanks",
  "fill_in_the_blanks_description": "Can you correctly identify what's missing?",
  "act_it_out": "Act it out",
  "act_it_out_description": "Can you select the correct response?",
  "act_it_out_listening": "Act it out - Listening",
  "act_it_out_listening_description": "Use your listening skills to select the correct response.",
  "act_it_out_speaking": "Act it out - Speaking",
  "act_it_out_speaking_description": "Practice your pronunciation by speaking your part.",
  "act_it_out_listening_speaking": "Act it out - Listening and Speaking",
  "act_it_out_listening_speaking_description": "Practice your pronunciation by speaking your part.",
  "select_role": "Select your role",
  "select_role_description": "Select the role you would like to play.",
  "mute": "Mute",
  "unmute": "Unmute",
  "replay": "Restart",
  "restart": "Restart",
  "group_courses": "Group courses",
  "select": "Select",
  "classroom_creator_welcome": "Getting started with your classroom",
  "classroom_creator_welcome_free_trial": "Welcome to your 30 day free trial of Nualang! To get you started, we have setup your first classroom.",
  "classroom_creator_add_courses": "Add courses",
  "classroom_creator_add_courses_desc": "Choose how you want to add courses to the classroom.",
  "classroom_creator_add_students_email": "Invite students",
  "classroom_creator_track_progress": "Track student activity",
  "classroom_creator_track_progress_desc": "Once students have joined the classroom, click to view their progress on the courses which have been added.",
  "forLang_and_learnLang_the_same": "Learn language and speaker language are the same. Translation exercise is disabled as a result",
  "english": "Béarla",
  "french": "Fraincis",
  "german": "Gearmáinis",
  "irish": "Gaeilge",
  "italian": "Iodálach",
  "portuguese": "Portaingéilis",
  "spanish": "Spainnis",
  "classroom": "Ranga",
  "close": "Close",
  "last": "Last",
  "update_avatar": "Update Avatar",
  "update_avatar_desc": "Update your personal avatar",
  "invite_students": "Invite Students",
  "share_student_link_desc": "Share the instructions below to invite students to join.",
  "invite_link_desc": "Please sign in or create an account on Nualang by clicking this invite link:",
  "join_instructions_1": "This will bring you to the ",
  "join_instructions_2": "I created for you, where you'll have to click ‘Join’",
  "enrollment_key_text": "and input the key: ",
  "copy_student_instructions": "Copy student instructions",
  "or_invite_via": "Or invite via",
  "invite_email_subject": "Invitation to join a Nualang",
  "dear_students": "Dear Students",
  "dashboard": "Dashboard",
  "preview_roleplay": "Preview Roleplay",
  "roleplay_preview": "Preview",
  "roleplay_preview_decription": "Preview the full roleplay script",
  "sort": "Sort",
  "sort_by": "Sórtáil De Réir",
  "newest": "Is Nuaí",
  "alphabetical": "Aibítreach",
  "recently_changed": "Athraithe Le Deireanas",
  "recently_viewed": "Feicthe Le Deireanas",
  "oldest": "Oldest",
  "default": "Réamhshocrú",
  "clear_filters": "Clear filters",
  "member": "Student",
  "stop_speaking": "Stop Speaking",
  "agree_to_terms_and_conditions_1": "I agree to the ",
  "nualang_terms": "Nualang terms",
  "agree_to_terms_and_conditions_2": ", including acceptance of our ",
  "privacy_policy": "Privacy and Data Protection policy",
  "first_classroom_description": "This is a classroom to help students speak {{learnLang}} with confidence.",
  "upload": "Upload",
  "download": "Download",
  "bot_sign_in_message": "You must be signed in to play this chatbot",
  "course_sign_in_to_access": "Sign in to access this course",
  "have_an_account": "Have an account?",
  "provide_a_little_more_information": "Provide a little more information",
  "instructions": "Instructions",
  "close_preview": "Close Preview",
  "classroom_creator_add_students_email_desc": "Click to explore different ways to invite students to your classroom.",
  "check_recognition": "Check speech recognition",
  "checking_recognition": "Checking speech recognition ...",
  "phrase_recognised": "Phrase recognised",
  "phrase_not_recognised": "Phrase not recognised",
  "speech_recognition_info": " Checking the speech recognition allows you to determine whether or not your students will have difficulty pronouncing this phrase in our exercises.",
  "speech_recognition_error_info": "We recognised your phrase as {{recognisedPhrase}}. We recommend that you reword the phrase and/or add an alternative version.",
  "my_library": "My Library",
  "add_own_exercise_message": "Create new {{exerciseName}} using templates created by you",
  "no_exercises_in_library": "There are no {{exerciseName}} created by you.",
  "classroom_invite_feature_disabled_message": "This feature is disabled because your students will be able to join this classroom automatically.",
  "skip_navigation": "Skip Navigation",
  "generate_roleplay": "Generate Roleplay",
  "choose_topic_for_roleplay": "Choose a topic for the roleplay",
  "roleplay_generated": "Roleplay Generated",
  "select_roleplay": "Select Roleplay",
  "chatgpt_roleplay_description": "This is a roleplay about {{topic}}",
  "check_answer": "Check Answer",
  "card": "Card",
  "banner": "Banner",
  "load_more": "Load More",
  "bot_input_placeholder": "Use the keyboard to type a message",
  "bot_input_mobile_placeholder": "Type a message...",
  "audio_only_mode": "Éist & Labhair",
  "audio_only_tooltip": "Athraigh go dtí an modh fuaime amháin",
  "switch_to_text": "Athraigh go téacs",
  "switch_to_text_tooltip": "Athraigh ar ais go dtí an modh téacs",
  "audio_only_title": "Labhair le {{botName}}",
  "audio_only_subtitle": "Comhrá labhartha go hiomlán — gan téacs ar bith. Moltar cluasáin.",
  "audio_only_mode_unavailable_fallback_chat": "Teastaíonn mód Éisteacht agus Labhairt don chleachtadh seo, ach níl sé ar fáil ar an ngléas seo — leanfar ar aghaidh sa mhód Comhrá ina ionad sin.",
  "microphone_ready": "Micreafón réidh",
  "bot_is_speaking": "Ag labhairt...",
  "thinking_indicator": "Ag smaoineamh...",
  "start_conversation": "Tosaigh an comhrá",
  "stop_button_label": "Stop",
  "stop_bot_message": "Stop guth an róbait comhrá",
  "choose_mode_text_option": "Comhrá",
  "choose_mode_text_option_desc": "Clóscríobh nó labhair do fhreagraí, ansin léigh nó éist le freagraí an róbait.",
  "bot_mode_in_progress_icon": "{{mode_name}} conversation currently in progress",
  "bot_mode_completed_icon": "{{mode_name}} completed {{counter}} time",
  "bot_modes_completed_icon": "{{mode_name}} completed {{counter}} times",
  "replay_button_label": "Athsheinn",
  "replay_bot_message": "Athdhéan teachtaireacht an róbat comhrá",
  "you": "Tusa",
  "ready_when_you_are": "Réidh nuair is mian leat",
  "bot_speaking_banner": "Tá {{botName}} ag labhairt",
  "listening_to_you": "Ag éisteacht leat",
  "bot_thinking_banner": "Tá {{botName}} ag smaoineamh",
  "one_moment": "Nóiméad amháin",
  "listen_first": "Éist ar dtús",
  "tap_when_done": "Tapáil nuair a bhíonn tú críochnaithe",
  "conversation_complete": "Comhrá críochnaithe",
  "exchanges_label": "Malartuithe",
  "time_spoken_label": "Am labhartha",
  "review_your_turns": "Athbhreithnigh do shealanna",
  "submit_to_teacher": "Cuir chuig an múinteoir",
  "great_job": "Maith thú!",
  "or": "nó",
  "choose_difficulty_of_roleplay": "Choose a difficulty for the roleplay",
  "child": "Child",
  "game_visibility": "Game Visiblity",
  "duplicate_course": "Duplicate Course",
  "amount_must_not_exceed_10": "Amount must not exceed 10",
  "amount_must_be_greater_than_0": "Amount must be greater than 0",
  "voice_pitch": "Voice Pitch",
  "voice_pitch_example": "Hello, my Name is {{name}}",
  "voice_pitch_disabled": "Adjusting the pitch is not possible for this voice.",
  "voice_pitch_x_low": "Very Low",
  "voice_pitch_low": "Low",
  "voice_pitch_medium": "Medium",
  "voice_pitch_high": "High",
  "voice_pitch_x_high": "Very High",
  "contact_us": "Contact Us",
  "contact_us_message": "Thank you for using Nualang. Please send your message below and we will get back to you at the earliest.",
  "expected_phrases": "Expected Phrases",
  "expected_phrases_info": "Phrases you expect your students to use during the exercise that you'd like to be recognised correctly when the student speaks. For example, if the exercise was about the weather you might want to recognise the word 'weather' more often than 'whether'",
  "add_expected_phrases": "Add Expected Phrases",
  "phrase_length_exceeded_error": "Phrase should not exceed 100 characters",
  "whats_new": "What's New",
  "wayside_subscription_message": "Your subscription is managed by Wayside Publishing",
  "select_the_correct_answer": "Select the correct answer",
  "pronunciation_score": "Pronunciation score",
  "pronunciation_score_explanation": "The pronunciation score is based on the number of words recognised correctly ({{transcriptCompletenessPercentage}}%) and how clearly they were recognised.",
  "add_course": "Add Course",
  "generate_roleplay_existing_script_confirmation": "Are you sure you want to replace the existing script?",
  "experimental_feature_desc": "New AI Feature - We would love to hear your feedback",
  "generating_roleplay": "Generating Roleplay",
  "updated": "Updated",
  "exercise_completed": "Exercise Completed",
  "exercise_not_completed": "Exercise Not Completed",
  "view_topic": "View Topic",
  "view_roleplay": "View Roleplay",
  "view_bot": "View Chatbot",
  "student_reports_problem": "A student reports a problem during an exercise",
  "problem_reported": "Problem reported",
  "remove_course_confirmation": "Are you sure you want to remove this course?",
  "classroom_member_limit_reached": "Classroom has reached its student limit",
  "upload_pdf": "Upload PDF",
  "remove_pdf": "Remove PDF",
  "classroom_updated": "Classroom Updated",
  "deleted": "Deleted",
  "created": "Created",
  "moderation_warning": "The following categories were detected in your uploaded image(s): ",
  "warning": "Warning",
  "use_anyways": "Use Anyways",
  "view_pdf": "View Story",
  "schedule_discussion": "Schedule discussion",
  "video_chat": "Video Chat",
  "video_chat_member": "Video Chat Member",
  "create_meeting": "Create meeting",
  "group_assignment": "Group assignment",
  "join_group": "Join Group",
  "groups": "Groups",
  "group": "Group",
  "welcome": "Welcome",
  "delete_pdf": "Delete PDF",
  "delete_pdf_confirmation": "Are you sure you want to delete this PDF?",
  "course_updated": "Course updated",
  "overwrite_phrases": "Overwrite Phrases",
  "roleplay_game_in_progress_icon": "Roleplay game currently in progress",
  "roleplay_game_completed_icon": "Roleplay game has been completed {{counter}} time",
  "roleplay_games_completed_icon": "Roleplay game has been completed {{counter}} times",
  "page": "Page",
  "unknown": "Anaithnid",
  "add_a_discussion_topic": "Cuir Ábhar Díospóireachta leis",
  "add_a_url_for_students_to_discuss": "Cuir URL le haghaidh na Mac Léinn Le Plé",
  "images_that_students_can_use_as_a_background_during_the_call": "Íomhánna a d'fhéadfadh na Mac Léinn a Úsáid mar Chúlra le linn na gCuirimí",
  "discussion_images": "Íomhánna Díospóireachta",
  "images_for_students_to_discuss_during_the_call": "Íomhánna le haghaidh na Mac Léinn Le Plé le linn na gCuirimí",
  "recording_time": "Am Taifeadta",
  "due_date": "Dáta deiridh",
  "interculturarity": "Idirchultúrachta",
  "comprehensibility": "Tuiscint",
  "function_and_text_type": "Feidhm agus Cineál Téacs",
  "vocabulary_in_context": "Foclóir i gCóntas",
  "Drag_and_drop_image_from_your_computer": "Tarraing agus Sáigh Íomhá ó do Ríomhaire",
  "record_time_limit": "Teorainn Am Taifeadta",
  "schedule_discussion_options": "Roghanna Sceideal Díospóireachta",
  "chat_options": "Roghanna Comhrá",
  "recording_info": "Submission Info",
  "discussion_id": "ID Díospóireachta",
  "discussion_prompt": "Spreagadh Díospóireachta",
  "attendees": "Teagmhálaithe",
  "created_discussions": "Díospóireachtaí Cruthaithe",
  "create_groups": "Cruthaigh Grúpaí",
  "select_all": "Roghnaigh Gach",
  "remove_group": "Gruaigh Grúpa",
  "grouped_discussions": "Díospóireachtaí Grúpaithe",
  "no_recordings_found": "Níor Aimseartha Taifeadta Faighte",
  "recordings": "Taifid",
  "scheduled_meetings": "Cruinnithe Sceidealta",
  "no_meetings_scheduled": "Gan Cruinnithe Sceidealta",
  "discussion_info": "Eolas Díospóireachta",
  "invites": "Cuireadh",
  "invited_members": "Baill Cuireadh",
  "minute": "Nóiméad",
  "feedback": "Aiseolas",
  "view": "Amharc",
  "no_data_found": "Gan Eolas Faighte",
  "no_past_discussions_found": "Gan Díospóireachtaí Roimheanna Faighte",
  "no_submissions_found": "Gan Sábháil Faighte",
  "background_images": "Íomhánna Cúlra",
  "no_scheduled_discussions_found": "Níor Aimseartha Díospóireachtaí Faighte",
  "view_more": "Féach Níos Mó",
  "past": "Thart",
  "submissions": "Seoladh",
  "add_a_discussion_prompt": "Cuir Spreagadh Díospóireachta leis",
  "join_live_game": "Join Live Game",
  "live_game_medals": "Boinn Cluiche Beo",
  "live_game_medals_description": "Díghlasáil boinn trí theacht sa 1ú, 2ú nó 3ú háit le linn Cluiche Beo",
  "classroom_has_no_live_game": "Classroom currently has no live game",
  "speech_recognition_error_info_no_phrase": "We did not recognise your phrase. We recommend that you reword the phrase and/or add an alternative version.",
  "no_conversation_available": "Níl Comhrá ar Fáil",
  "enrolment_key_min_chars": "Enrolment key must be at least 5 characters long",
  "zoom_in": "Zoom In",
  "zoom_out": "Zoom Out",
  "game_created": "Game created",
  "play_live": "Play Live",
  "play_live_desc": "Select the exercise you'd like to play live in the classroom.",
  "live_dialog_description": "Select the exercise you'd like to play live in the classroom.",
  "no_special_characters": "Cannot contain special characters",
  "required": "Required",
  "course_deletion_note": "*Note deleting this course will also delete the {{sectionCount}} section(s) in this course and its contents",
  "classroom_deletion_note": "*Note deleting this classroom will also delete the {{courseCount}} course(s) in this classroom and its contents",
  "topic_deletion_note": "*Note deleting this topic will also delete the {{phraseCount}} phrase(s), {{botCount}} chatbot(s) and {{roleplayCount}} roleplay(s) in this topic and its contents",
  "section_deletion_note": "*Note deleting this section will also delete the {{topicCount}} topic(s) in this section and its contents",
  "confirmDeletionText": "To confirm deletion, type 'delete' into the field below",
  "subscription_status_cancelled": "Cancelled",
  "subscription_status_active expired": "Expired",
  "subscription_status_active_expired": "Expired",
  "nuala_performance_rating": "Nuala Performance Rating",
  "using_nuala_performance": "If you use Nuala Performance Rating, you will lose any manually created grading.",
  "are_you_sure_nuala_performance": "Are you sure you want to use Nuala Performance Rating?",
  "leaderboard": "Leaderboard",
  "waiting_message": "Get ready, the game will start soon",
  "play_game": "Play Game",
  "close_game": "Close Game",
  "cancel_game": "Cancel Game",
  "end_game": "End Game",
  "games": "Games",
  "course_no_sections": "This course has no sections",
  "topic_no_phrases": "This topic has no phrases",
  "next_question": "Next question",
  "your_answer": "Your answer",
  "change_answer": "Change answer",
  "final_results": "Results",
  "game_ended": "Game ended",
  "joined_game": "Joined game",
  "equipment_problem_label": "Equipment problem",
  "equipment_problem_example": "e.g. My speaker or microphone is not working",
  "technical_problem_label": "Technical problem",
  "technical_problem_example": "e.g. The app is not working correctly",
  "content_problem_label": "Content problem",
  "content_problem_example": "e.g. I noticed a mistake in the exercise content",
  "end_question_early": "End Question Early",
  "discussion_topic": "Discussion Topic",
  "discussion_link": "Discussion Link",
  "scheduled": "Scheduled",
  "go_back_to_classroom": "Go back to Classroom",
  "discussion_created": "Díospóireacht Cruthaithe",
  "discussion_updated": "Díospóireacht nuashonraithe",
  "give_feedback": "Tabhair Aiseolas",
  "nualang_live_welcome": "Welcome to Nualang Live!",
  "nualang_live_invite": "Invite Students",
  "nualang_live_invite_desc": "Click here to see how students join the game.",
  "nualang_live_game_members": "Game Members",
  "nualang_live_game_members_desc": "Click here to see who hasn't joined the game yet.",
  "nualang_live_start_game": "Start the game!",
  "nualang_live_settings": "Game Settings",
  "nualang_live_settings_desc": "Click here to see game options",
  "timer_length": "Timer Length",
  "keyboard_and_word_bank": "Keyboard and Word Bank",
  "keyboard_only": "Keyboard Only",
  "word_bank_only": "Word Bank Only",
  "answer_options": "Answer Options",
  "game_settings": "Game Settings",
  "create_feedback": "Create Feedback",
  "first_place": "First Place",
  "second_place": "Second Place",
  "third_place": "Third Place",
  "final_score": "Final Score",
  "no_discussions_found": "Níor aimsíodh aon díospóireachtaí",
  "no_discussions_found_desc": "Is féidir gach díospóireacht agus seoladh a aimsiú anseo",
  "quality_of_interaction": "Cáilíocht na nIdirghníomhaíochta",
  "number_of_questions": "Number of Questions",
  "estimated_game_time": "Estimated Game Time",
  "minutes": "Minutes",
  "discuss": "Plé",
  "open_live_game": "Open Live Game",
  "correct_answers": "Correct Answers",
  "game_has_ended": "This game has ended, please wait for a new Live Game.",
  "game_has_canceled": "This game has been canceled, please wait for a new Live Game.",
  "allow_wordBank": "Allow students to use the word bank in exercises",
  "creator_default": "Creator's default",
  "course_default": "Course default",
  "course_settings_description": "Adjust the learning experience for students of this classroom",
  "change_settings": "Change Settings",
  "choose_topic_from_pdf_for_roleplay": "Choose a topic for the roleplay based on context from the course pdf",
  "use_context_from_course_pdf": "Use context from course pdf",
  "use_context_from_course_pdf_info": "Turn this on to be able to generate a roleplay based on the contents of the course pdf if the  prompt is relevent to the contents in the pdf",
  "feedback_all_info": "Cuirtear aiseolas ar fáil do gach ball de ghrúpa an díospóireachta. Ní féidir aiseolas grúpa agus aonair a chur ar fáil do mhac léinn araon.",
  "rubric_info_desc": "View the Analytic Growth Rubric, the criteria being used in our AI feedback.",
  "rubric_info": "Eolas Rúbairc",
  "listen_to_story": "Listen to the Story",
  "roleplay_no_interactions": "This roleplay has no interactions",
  "number_of_interactions": "Number of Interactions",
  "archive_title_submissions": "Archive Submissions",
  "archive_description_submissions": "Are you sure you want to archive the submissions?",
  "archive_title": "Archive Discussion",
  "archive_description": "Are you sure you want to archive this discussion? Students invites to this discussion will also be removed.",
  "discussion_templates": "Tumchláir Díospóireachta",
  "discussion_templates_desc": "Bain úsáid as ceann deárna ár mballaí díospóireachta réamhshocraithe, anseo chun cabhrú leat ábhar a chruthú d'fhochéimithe",
  "find_courses": "Find Courses",
  "create_your_own": "Create Your Own ",
  "community_courses_description": "Find a course from the library for your students",
  "create_your_own_description": "Build a brand new course for your students",
  "empty_live_dialog_description": "Add a course if you'd like to play live in the classroom.",
  "no_classroom_to_join": "Your teacher has not setup their classroom on Nualang yet. Please ask them to do so, then try again.",
  "resume": "Resume",
  "pause": "Pause",
  "discuss_welcome": "Discuss Guide",
  "discuss_scheduled_discussions": "Scheduled Discussions",
  "discuss_scheduled_discussions_desc": "This is where you will find scheduled discussions created by the teacher. You will be able to join these discussions and talk about a topic with other students in your group.",
  "discuss_refresh_discussions": "Refresh Discussions",
  "discuss_refresh_discussions_desc": "This button will allow you to refresh to get the latest scheduled discussions.",
  "discuss_recorded_discussions": "Record Discussions",
  "discuss_recorded_discussions_desc": "Here you can find discussions you have recorded and submitted for the teacher to review. Once feedback is given you will be able to view it.",
  "discuss_grouped_discussions": "Grouped Discussions",
  "discuss_grouped_discussions_desc": "Here you can find all the discussions you have created for your students based on the topic name. Click into a grouped discussion to see what student groups were created.",
  "discuss_submissions": "Discussion Submissions",
  "discuss_submissions_desc": "Here you can find the recorded discussion submissions created by groups of students. You can view their recording, as well as the transcript of the discussions and give individual or grouped feedback.",
  "refresh_discuss": "Refresh Discuss",
  "nuala_ai": "Nuala AI",
  "performance_ratings": "Performance Ratings",
  "attended": "Attended",
  "did_not_attend": "Did Not Attend",
  "discussion_attendance": "Discussion Attendance",
  "submitted_recordings": "Submitted Recordings",
  "invalid_date": "Invalid Date",
  "go_to_profile_settings": "Go to profile settings",
  "not_applicable": "Omit",
  "comprehension": "Comprehension",
  "feedback_text": "Feedback Text",
  "submit_feedback": "Submit Feedback",
  "select_students_to_group": "Select All Students",
  "created_groups": "Created Groups",
  "feedback_info": "Feedback Info",
  "sample_discussion_ideas": "Sample Discussion Ideas",
  "image_library": "Image Library",
  "interculturality": "Interculturality",
  "add_alternative_version_explanation": "Add an alternative version of the phrase to be marked as correct e.g 'You are welcome' could be an alternative to 'You're welcome'",
  "upload_video": "Uaslódáil Físeán",
  "select_video_desc": "Tarraing agus scaoil físeán ó do ríomhaire",
  "add_video": "Cuir Físeán Leis",
  "video_info": "Físeán an Chúrsa",
  "play_video": "Imir Físeán",
  "delete_video": "Scrios Físeán",
  "delete_video_confirmation": "An bhfuil tú cinnte go bhfuil tú ag iarraidh an físeán seo a scriosadh?",
  "view_video": "Féach ar an bhFíseán",
  "video_options": "Roghanna Físeáin",
  "congratulations": "Congratulations!",
  "medal_has_been_added_to_your_profile": "A medal has been added to your profile",
  "pdf_options": "PDF Options",
  "disable_keyboard": "Disable Keyboard",
  "enable_keyboard": "Enable Keyboard",
  "view_story": "View Story",
  "view_question": "View Question",
  "save_library": "Save to Library",
  "minimum_two_phrases": "This exercise requires a minimum of two phrases in the topic.",
  "roleplay_not_valid": "This exercise requires a minimum of one interaction and one question.",
  "move_topic": "Move Topic",
  "move_section": "Move Section",
  "move_roleplay": "Move Roleplay",
  "duplicate_roleplay": "Duplicate Roleplay",
  "leave_game": "Leave Game",
  "leave_game_confirmation": "Are you sure you want to leave this game?",
  "leave": "Leave",
  "explore": "Explore",
  "listen": "Listen",
  "download_template": "Download Template",
  "member_activity": "Student Activity",
  "move_phrase": "Move Phrase",
  "multiple_choice": "Multiple Choice",
  "record": "Record",
  "nualang_live_help": "How to play",
  "nualang_live_help_desc": "Click here to see how to play the game",
  "roleplay-story": "Story",
  "teach_classrooms_desc": "Manage and interact with your students in a dynamic learning environment",
  "teach_classrooms_title": "Engage Your Classroom",
  "teach_courses_desc": "Design and structure your curriculum to provide a complete learning experience",
  "teach_courses_title": "Build comprehensive courses",
  "teach_roleplays_title": "A new kind of Roleplay",
  "teach_roleplays_desc": "Teaching with roleplays allows your students to participate in scripted conversations, providing a dynamic and immersive way to practice their language skills",
  "teach_bots_title": "Creativity with chatbots",
  "teach_bots_desc": "Teaching with chatbots can help your students develop confidence and a natural conversational style that flows seamlessly, similar to real-life conversations",
  "learn_bots_title": "Creativity With Chatbots",
  "learn_bots_desc": "Learning with chatbots can help you develop a natural and engaging conversational style that flows seamlessly, just like a real conversation",
  "learn_roleplays_title": "A new kind of Roleplay",
  "learn_roleplays_desc": "Learning with roleplays allows you to participate in scripted conversations, providing a dynamic and immersive way to practice language skills",
  "learn_classrooms_desc": "Join classrooms where you can interact with your peers and teachers in a dynamic learning environment",
  "learn_classrooms_title": "Interactive Learning Spaces",
  "learn_courses_desc": "Enroll in courses designed to give you a complete learning experience with structured lessons and activities",
  "learn_courses_title": "Comprehensive learning paths",
  "video_included": "Video",
  "story_included": "Story",
  "answer_helper_text": "Press enter / return key to add answer.",
  "move_answer": "Move Answer",
  "remove_answer": "Remove Answer",
  "remove_question": "Bain an Cheist",
  "supported_file_types": "Supported file types: mp4, mov",
  "exercise_description": "Listen to this phrase",
  "translate_description": "Translate the phrase as quick as you can for the most points!",
  "result_description": "See where you place against everyone else!",
  "listening_description": "Choose an answer as quick as you can for the most points!",
  "roleplay_intro": "Listen to the conversation between the two characters!",
  "topic_no_roleplays": "This topic has no roleplays.",
  "case_sensitive": "This was marked for case sensitivity",
  "required_field": "Fields marked with * are required",
  "close_drawer": "Close Drawer",
  "generate_question": "Generate Question",
  "generating_question": "Generating Question",
  "experimental_feature_desc_answer": "The 'Generate Question' button is a New AI Feature - We would love to hear your feedback",
  "question_type": "Question Type",
  "multiple_choice_factual": "Multiple Choice - Factual",
  "multiple_choice_inference": "Multiple Choice - Inference",
  "vocabulary": "Vocabulary",
  "true_false": "True/False",
  "insert_emoji": "Insert Emoji",
  "moderation_reason": "Image was blocked for containing: {{moderationReason}}",
  "move_bot": "Move Chatbot",
  "duplicate_bot": "Duplicate Chatbot",
  "experimental_feature_desc_phrases": "The 'Generate Phrases' button is a New AI Feature - We would love to hear your feedback",
  "choose_topic_for_phrases": "What would you like the phrases to be about?",
  "how_many_phrases": "Number of Phrases: {{phraseAmount}}",
  "generate_phrases": "Generate Phrases",
  "generating_phrases": "Generating Phrases",
  "discuss_description": "Discuss is your platform for live, interactive conversations. Create engaging discussions based on your prompts or choose from suggested topics. Watch as your students collaborate and share ideas in real-time.",
  "enable_discuss": "Enable Discuss in Settings",
  "duplicate_answer_desc": "A question cannot have duplicate answers",
  "incomplete_translation": "There is still more to this sentence!",
  "question_language": "Choose a language for the questions and answers",
  "generate_questions": "Generate Questions",
  "enable_gen_questions": "Enable this to generate comprehension questions related to the roleplay.",
  "use_topic_phrases": "Use Topic Phrases",
  "enable_phrase_context": "Enable this to use the phrases from your Topic as context in generating the roleplay.",
  "add_phrase_context": "Please add phrases to your topic to enable this feature.",
  "enter_phrase_with_alternatives": "Enter a phrase with alternatives",
  "sentences": "Sentences",
  "words": "Words",
  "phrase_type": "Phrase Type",
  "archive_classroom": "Archive Classroom",
  "archive_classroom_confirmation": "Are you sure you want to archive this classroom?",
  "unarchive_classroom": "Unarchive Classroom",
  "unarchive_classroom_confirmation": "Are you sure you want to unarchive this classroom?",
  "confirmArchiveText": "To confirm archiving, type 'archive' into the field below",
  "confirmUnarchiveText": "To confirm unarchiving, type 'unarchive' into the field below",
  "generate_bot": "Generate Chatbot",
  "generating_bot": "Generating Chatbot",
  "choose_topic_for_bot": "What would you like this chatbot to be about?",
  "use_context_from_topic_phrases": "Use topic phrases",
  "generate_bot_existing_script_confirmation": "Are you sure you want to replace the existing script?",
  "voice_speed": "Voice Speed",
  "phrase_to_speak": "Phrase to Speak",
  "voice_speed_extra_slow": "Extra Slow",
  "voice_speed_slow": "Slow",
  "voice_speed_medium": "Medium",
  "voice_speed_fast": "Fast",
  "voice_speed_extra_fast": "Extra Fast",
  "play_audio": "Play Audio",
  "generate_audio": "Generate Audio",
  "topic_goal": "Communicative goal",
  "topic_goal_info_text": "What do you want the learner to be able to do at the end of this lesson?",
  "archived_classrooms_title": "No Archived Classrooms",
  "archived_classrooms_desc": "When you're finished with a classroom, you can archive it. This will archive the classroom for all students and collaborators.",
  "bot_created": "Chatbot Created",
  "bot_deleted": "Chatbot Deleted",
  "ukrainian": "Úcráinis",
  "arabic": "Arabic",
  "chinese_simplified": "Chinese Simplified",
  "chinese_traditional": "Chinese Traditional",
  "czech": "Czech",
  "danish": "Danish",
  "dutch": "Dutch",
  "filipino": "Filipino",
  "greek": "Greek",
  "hindi": "Hindi",
  "hungarian": "Hungarian",
  "indonesian": "Indonesian",
  "japanese": "Japanese",
  "korean": "Korean",
  "malay": "Malay",
  "polish": "Polish",
  "punjabi": "Punjabi",
  "romanian": "Romanian",
  "swahili": "Swahili",
  "thai": "Thai",
  "turkish": "Turkish",
  "vietnamese": "Vietnamese",
  "speak_disabled": "Speak disabled",
  "move_message": "Move Message",
  "move_question": "Move Question",
  "topic_goal_placeholder": "e.g I can ask and answer questions about my identity.",
  "download_csv_template": "Download CSV Template",
  "upload_csv": "Upload CSV",
  "remove_csv": "Remove CSV",
  "single_phrase": "Single Phrase",
  "list_of_phrases": "List of Phrases",
  "text_studio": "Text-to-Speech Studio",
  "text_studio_description": "The Nualas are here to help you turn text into speech, select a language and choose from our selection of voices to bring your text to life.",
  "no_phrases_yet": "No phrases yet...",
  "access_denied_domain_unverified": "Access Denied: Domain Unverified",
  "file_name": "File Name",
  "download_audio": "Download Audio",
  "no_answer": "No Answer",
  "left_group": "Left Group",
  "view_feedback": "View Feedback",
  "no_feedback": "You have not given this student feedback yet",
  "app_search_placeholder": "Search community content",
  "delete_phrases": "Delete Phrases",
  "delete_phrases_confirmation": "Are you sure you want to delete the chosen phrases?",
  "share_audio": "Please uncheck this box if you do not want to share your audio with Nualang. Sharing the audio will help us diagnose the issue.",
  "edit_phrase": "Edit phrase",
  "share_screenshot": "Please check this box if you would like to share your screenshot with Nualang. Sharing the screenshot will help us diagnose the issue.",
  "screenshot_captured": "Screenshot captured:",
  "classroom_creator_play_live_game": "Play Nualang LIVE",
  "classroom_creator_play_live_game_desc": "Nualang LIVE offers customisable games that create a dynamic and engaging environment for students, allowing them to test their skills and compete against each other to win coveted Nuala medals.",
  "content_tags": "Add Tags",
  "enter_info_tags": "Enter a comma separated list of tags below.",
  "enter_collaborator_email": "Enter a comma or space separated list of email addresses below. Collaborators can manage courses, students, and classroom settings.",
  "enter_domains_info": "Enter a comma or space separated list of school domains below.",
  "search_error": "Tharla earráid le linn cuardaigh, déan iarracht arís le do thoil",
  "create_feedback_error": "Tharla earráid le linn aiseolais a chruthú, déan iarracht arís le do thoil",
  "get_recs_error": "Tharla earráid agus taifid á fháil",
  "get_image_error": "Tharla earráid agus íomhánna á fháil",
  "update_discussion_error": "Tharla earráid le linn nuashonrú na díospóireachta, déan iarracht arís le do thoil",
  "invite_users_error": "Tharla earráid le linn úsáideoirí a thabhairt cuireadh dóibh, déan iarracht arís le do thoil",
  "create_image_error": "Tharla earráid le linn an íomhá a uaslódáil, déan iarracht arís le do thoil",
  "grade_conversation_error": "Tharla earráid agus comhrá á ghrádú, déan iarracht arís le do thoil",
  "get_transcript_error": "Tharla earráid agus tras-scríbhinn á fáil, déan iarracht arís le do thoil",
  "get_subs_error": "Tharla earráid agus na haighneachtaí á fáil, déan iarracht arís le do thoil",
  "delete_picture_confirmation": "Are you sure you want to delete this picture?",
  "inappropriate_language_detected": "Inapproriate Language Detected",
  "schedule_discussion_error": "Tharla earráid le linn an phleanáil a dhéanamh ar an bplé, déan iarracht arís le do thoil",
  "heritage_speaker": "Read/Write",
  "unmark_as_heritage_speaker": "Disable Read/Write Mode",
  "mark_as_heritage_speaker": "Enable Read/Write Mode",
  "heritage_speaker_desc": "Focuses on reading and writing by disabling listening and speaking where appropriate. Designed with heritage learners in mind.",
  "heritage_speaker_point_1": "The word bank will be disabled",
  "heritage_speaker_point_2": "Listening and pronunciation will be disabled where appropriate.",
  "freely_changed": "This can be freely changed at any time.",
  "mark_as_challenge_student": "Enable Challenge Mode",
  "unmark_as_challenge_student": "Disable Challenge Mode",
  "mark_as_challenge_bot": "Mark as Challenge Mode",
  "unmark_as_challenge_bot": "Unmark as Challenge Mode",
  "challenge_student": "Challenge Mode",
  "challenge_student_desc": "Unlocks chatbots that prompt extended responses and formal, academic language. Designed with heritage learners in mind.",
  "challenge_bot": "Challenge Mode",
  "challenge_bot_desc": "This chatbot is visible only to students with Challenge Mode enabled in the Students tab. Designed with heritage learners in mind, it provides formal, academic prompts.",
  "rewatch_tutorial": "Rewatch Tutorial",
  "heritage_speaker_progress": "Students marked as 'Read/Write' will have their learning experience adjusted to focus more on reading and writing.",
  "generate_transcript": "Generate Transcript",
  "suggested_images": "Suggested Images",
  "auto_generate_phrase_translation": "Generate Translations",
  "word_near_correct": "This word is correct, but it is in the wrong position",
  "partially_correct": "Partially Correct",
  "tag_info": "Tags help organize and categorize content, making it easier to find and group related materials. Use tags to improve the discoverability of your content and streamline your workflow.",
  "assignments": "Assignments",
  "assign_exercises": "Assign Exercises",
  "assign_exercises_desc": "Select activities from your curated library of content and assign them to your students with just a few clicks. Watch as they engage with exercises designed to reinforce learning, practice skills, and deepen understanding.",
  "assign_discuss": "Assign Discuss",
  "assign_discuss_desc": "Discuss is your platform for live, interactive conversations. Create engaging discussions based on your prompts or choose from suggested topics. Watch as your students collaborate and share ideas in real-time.",
  "archive_discussions": "Archived Discussions",
  "archive_submissions": "Archived submissions",
  "assignment": "Assignment",
  "create_assignment": "Create Assignment",
  "no_assignments": "No Assignments",
  "assignments_description": "Assignments are a great way to engage your students with interactive content. Create assignments to reinforce learning, practice skills, and deepen understanding.",
  "no_assignments_desc": "There are no assignments in this classroom yet.",
  "select_classroom": "Select Classroom",
  "assignment_title": "Assignment Title",
  "assignment_description": "Assignment Description",
  "select_members": "Select Students",
  "schedule_assignment": "Schedule Assignment",
  "assign_date": "Available From",
  "add_exercise": "Add Exercise",
  "add_exercises": "Add Exercises",
  "assign_exercises_description": "Select exercises from your library to assign to your students",
  "due_in": "Due in",
  "due_tomorrow": "Due Tomorrow",
  "student_edited_transcript": "Rinne an mac léinn eagarthóireacht láimhe ar an tras-scríbhinn seo tar éis taifeadta.",
  "member_updated": "Student updated",
  "delete_assignment": "Delete Assignment",
  "delete_assignment_confirmation": "Are you sure you want to delete this assignment?",
  "assignment_deleted": "Assignment deleted",
  "assignment_created": "Assignment created",
  "assignees_created": "Assignees created",
  "classroom_creator_subscription_expired": "The creator's subscription has expired.",
  "return_to_classrooms": "Return to Classrooms",
  "creator_not_subscribed_upgrade_title": "Subscription Expired",
  "creator_not_subscribed_upgrade": "Your subscription has expired. Please upgrade plan in order to continue the following features:",
  "creator_not_subscribed_upgrade_description": "Student access to classroom activities.",
  "creator_not_subscribed_upgrade_description2": "Ability to create Nualang LIVE games",
  "creator_not_subscribed_upgrade_description3": "Student ability to join classroom.",
  "due_today": "Due Today",
  "update_assignment": "Update Assignment",
  "refresh_assignments": "Refresh Assignments",
  "report_type": "Type",
  "go_back_to_assignments": "Go back to Assignments",
  "available_today": "Available Today",
  "available_tomorrow": "Available Tomorrow",
  "available_in": "Available in",
  "not_assigned": "Not Assigned",
  "assigned": "Assigned",
  "view_assignment": "View Assignment",
  "no_assignments_description": "There are currenly no assignments created.",
  "no_shared_courses": "Níl aon chúrsaí roinnte idir na seomraí ranga roghnaithe.",
  "view_submissions": "View Submissions",
  "archive": "Archive",
  "generated_phrases": "Are you sure you want to add the following generated phrases to the list? These phrases will be appended and will not replace any existing phrases.",
  "everyone": "Everyone",
  "discussions": "Discussions",
  "duplicate_course_confirmation": "This will make a copy of the course that you can edit. You won't get updates or changes from the original course.",
  "duplication": "Allow others to duplicate this course.",
  "invalid_email_format": "Invalid email format",
  "email_domain_mismatch_error": "Email must be from your domain ({{domain}}).",
  "generic_email_domain_error": "Generic email domain error",
  "duplicate_disabled_tooltip": "This course has been disabled for duplication by the creator.",
  "collaborators_only": "Collaborators",
  "hide_course": "Hide Course",
  "show_course": "Show Course",
  "default_assignment_title": "New Classroom Assignment",
  "default_assignment_instructions": "Please complete the tasks below before the due date.",
  "due": "Due",
  "hide_from_students": "Hide from Students",
  "show_to_students": "Show to Students",
  "hello": "Dia duit",
  "dynamic_response": "Dynamic Responses",
  "dynamic_response_desc": "Allow Chatbots in this Classroom to generate customized replies based on student input, powered by AI.",
  "assign_to": "Assign To",
  "all_students": "All Students",
  "ai_chatbot_message_info": "This chatbot message is generated using AI.",
  "ai_chatbot_message_generating_info": "This chatbot message is being generated using AI.",
  "language_correction": "Ceartúchán teanga",
  "correction_original": "Bunleagan",
  "correction_suggested": "Moladh",
  "language_corrections_to_review": "Ceartúcháin teanga le hathbhreithniú",
  "dynamic_responses_info": "Enabling this feature allows the Chatbots to use AI to generate personalized responses based on what students say. While this can support more engaging learning, responses are automatically generated and may vary. All AI use follows clear, trusted standards to ensure safe, responsible, and accountable learning.",
  "paste_your_csv_data": "Paste your CSV data here",
  "user_level_settings": "Socruithe Leibhéal Úsáideora",
  "chatbot_dynamic_responses": "Chatbot - Freagraí Dinimiciúla",
  "chatbot_dynamic_responses_desc": "Má tá an freagra dinimiciúil ar siúl, éistfidh an Chatbot go gníomhach agus oiriúnóidh sé, ag lorg níos mó sonraí, frásaí níos soiléire, nó freagraí réalaíocha, seachas bogadh go dtí an chéad leid réamhshocraithe eile.",
  "chatbot_now_ai": "Nualang Chatbot: Now with Real-Time Feedback",
  "chatbot_now_ai_desc": "More speaking support. Same structure. No extra work. Students now get helpful, AI-enhanced feedback as they chat!",
  "chatbot_now_ai_revert_settings": "You can limit AI anytime in your ",
  "prefer_original_version": "Prefer the original version?",
  "chatbot_now_ai_benefit": "It’s like giving every student a conversation coach built right into the activity—with zero extra prep or grading.",
  "ai_learn_more": "Want to learn more? Read our approach to AI safety and trust.",
  "ai_settings_desc": "Choose which AI features are available in this classroom.",
  "limit_ai": "AI in this classroom",
  "limit_ai_desc": "Allow the AI features below in this classroom or disable them entirely.",
  "limit_ai_info": "Disabling AI in this classroom turns off each AI feature below at once: Chatbot dynamic responses and AI-generated feedback on Discuss recordings. Teachers can still write and submit their own feedback. All AI use follows clear, trusted standards to ensure safe, responsible, and accountable learning.",
  "limit_ai_course_desc": "Turn chatbot dynamic responses off for this course only. The classroom setting applies unless you change it here.",
  "chatbot_ai": "Chatbot - Dynamic Responses",
  "chatbot_ai_desc": "Allow AI to generate feedback and responses to students or disable to use scripted replies.",
  "discuss_ai": "Discuss - AI feedback",
  "discuss_ai_desc": "Allow AI to generate draft feedback on student submissions or disable to require teacher created feedback only.",
  "ai_allowed": "Enabled",
  "ai_limited": "Disabled",
  "ai_limited_classroom_notice": "AI is disabled in this classroom, the features below are unavailable.",
  "ai_locked_notice": "AI is limited for your whole organization, so it cannot be changed here. Contact your Nualang administrator if this needs to change.",
  "ai_partly_locked_notice": "Some AI features are limited for your whole organization, so they cannot be changed here. Contact your Nualang administrator if this needs to change.",
  "ai_overview_desc": "AI settings for every classroom you teach, including ones you co-teach. Changes apply to the classroom straight away.",
  "ai_overview_empty": "You don't teach any classrooms yet.",
  "ai_overview_load_failed": "Your classrooms could not be loaded. Please try again.",
  "ai_overview_save_failed": "This change could not be saved",
  "ai_overview_apply_all": "Apply to all",
  "ai_overview_enable_all": "Enable for all classrooms",
  "ai_overview_disable_all": "Disable for all classrooms",
  "ai_overview_apply_all_count": "Classrooms that will change",
  "ai_overview_apply_all_skips": "Archived classrooms, and settings fixed by your organization, are not changed.",
  "ai_overview_apply_all_saved": "Classrooms updated",
  "ai_overview_apply_all_failed": "These classrooms could not be updated",
  "ai_overview_course_overrides": "Courses with the chatbot disabled",
  "ai_overview_open_classroom": "Classroom settings",
  "ai_overview_no_active": "All your classrooms are archived.",
  "ai_course_overrides_notice": "Allowed for this classroom, but disabled for these courses",
  "ai_per_course_hint": "You can also limit chatbot dynamic responses for individual courses in Course settings below.",
  "ai_limited_feedback_blocked": "AI is limited for this classroom, so AI feedback cannot be generated.",
  "ai_settings": "AI Settings",
  "student_sent_inappropriate_messages": "Tá gá le do léirmheas ar an trascríbhinn thíos.",
  "challenge_mode": "Challenge Mode",
  "student_misuse_reported": "Student Misuse Reported",
  "student_acts_inappropriately": "Bíonn mac léinn ag gníomhú go míchuí le linn cleachtadh Chatbot",
  "ai_chatbot_error_response": "Tá brón orm gur rinne mé botún i mo fhreagra. Déan iarracht arís, le do thoil!",
  "no_members_tooltip": "Cannot perform this action because there are no students or courses in this classroom.",
  "overdue": "Overdue",
  "due_next": "Due Next",
  "active": "Active",
  "archived": "Archived",
  "past_due": "Past Due",
  "available_from": "Available from",
  "roleplay-fill-in-the-blanks": "Scenario fill in the blanks",
  "roleplay-act-it-out": "Scenario act it out",
  "roleplay-act-it-out-listening": "Scenario act it out listening",
  "roleplay-act-it-out-speaking": "Scenario act it out speaking",
  "roleplay-act-it-out-listening-speaking": "Scenario act it out listening and speaking",
  "generate_discussion": "Generate Discussion",
  "generating_discussion": "Generating Discussion",
  "discuss_prompt_language": "Choose a language for the discussion prompt",
  "level": "Level",
  "grouped_discussion": "Grouped Discussion",
  "not_present": "Was not present for the discussion",
  "view_recording": "View Recording",
  "generate_feedback": "Generate Feedback",
  "generate_feedback_for_all": "Generate Feedback for All",
  "performance_rating": "Performance Rating",
  "feedback_submitted": "Feedback Submitted",
  "group_not_submitted": "Group has not submitted a recording yet",
  "this_classroom_is_archived": "This classroom is archived",
  "submission_graded": "Submission Graded",
  "view_submission": "View Submission",
  "show_more": "Show more",
  "show_less": "Show less",
  "submit_feedback_confirmation": "Have you reviewed all generated feedback and are you ready to submit it to students?",
  "submit_feedback_scroll": "Review all feedback before submitting it to students",
  "ai_draft_not_edited": "AI draft, not edited",
  "edited_by_you": "Edited by you",
  "approved": "Approved",
  "approve": "Approve",
  "undo": "Undo",
  "x_of_n": "{{x}} of {{n}}",
  "ai_drafts_reviewed": "AI drafts reviewed",
  "approve_ai_drafts_to_submit_one": "Approve {{count}} AI draft to submit",
  "approve_ai_drafts_to_submit_other": "Approve {{count}} AI drafts to submit",
  "ai_suggested": "AI-suggested",
  "ai_suggested_tooltip": "Your teacher used AI to draft this feedback and sent it to you.",
  "course_topic": "Course Topic",
  "discussion_topic_helper": "Select a relevant topic to help generate the discussion.",
  "no_groups_created_yet": "No groups created yet",
  "select_students_from_the_list": "Select students from the list on the left to create a group",
  "drop_members_here": "Drop students here to create a group",
  "drag_a_student_here": "Drag a student here to create a group",
  "new_group": "New Group",
  "cannot_edit_discussion": "Cannot edit discussion with existing submissions",
  "generating_feedback": "Generating Feedback",
  "conversations_graded_success": "Feedback Generated",
  "below_level": "Below Level",
  "at_level": "At Level",
  "above_level": "Above Level",
  "ai_performance_assessment": "AI Performance Assessment",
  "performance_chip_tooltip": "Indicates how a student’s performance compares to the expected proficiency range, based on AI analysis.",
  "performance_chip_note": "Visible only to teachers and intended to support instructional review.",
  "you_are_human": "Más duine thú, fág an réimse seo folamh.",
  "progress": "Progress",
  "no_scheduled_assignments": "No Scheduled Assignments",
  "no_past_due_assignments": "No Past Due Assignments",
  "no_past_due_discussions": "No Past Due Discussions",
  "no_archived_discussions": "No Archived Discussions",
  "no_discussions": "No Discussions",
  "no_discussions_description": "Discussions are a great way to engage your students with collaborative conversations. Create discussions to practice speaking, build confidence, and develop communication skills.",
  "meaning": "Meaning",
  "meaning_exercise_desc": "Match definitions to the correct phrase.",
  "meaning-listen-and-speak": "Ciall - Éist & Labhair",
  "meaning_listen_and_speak_exercise_desc": "Éist leis an sainmhíniú agus abair an frása ceart.",
  "meaning-read-and-write": "Ciall - Léigh & Scríobh",
  "select_the_correct_phrase": "Roghnaigh an frása ceart don sainmhíniú seo",
  "chinese": "Sínis",
  "custom_feedback_placeholder": "Roghnach: cuir treoracha breise leis chun an t-aiseolas a dhíriú (m.sh. cruinneas, castacht, nó úsáid struchtúr spriocdhírithe).",
  "generate_feedback_view_the": "Féach ar an",
  "generate_feedback_rubric_name": "Rubric Fáis Anailísigh",
  "generate_feedback_rubric_desc": "na critéir atá in úsáid inár bhfuascailt AI.",
  "late_submission": "Aighneacht Dhéanach",
  "days_late_one": "{{count}} lá déanach",
  "days_late_other": "{{count}} lá déanach",
  "phrase_definition": "Sainmhíniú ar an bhfrása",
  "phrase_definition_helper_text": "Press enter / return key to add definition.",
  "generate_definitions": "Gin sainmhínithe",
  "phrases_exercise_desc": "Practice key phrases you'll use in conversations.",
  "phrase_group_name": "Phrase List Name",
  "create_phrase_group": "Create Phrase List",
  "preview_phrases": "Preview Phrases",
  "show_keyboard": "Show Keyboard",
  "hide_exercise": "Hide Exercise",
  "phrase_list": "Phrase List",
  "phrase_lists": "Liostaí frásaí",
  "no_phrase_lists": "Gan liostaí frásaí",
  "all_phrase_lists": "Gach liosta frásaí",
  "edit_phrase_list": "Edit Phrase List",
  "hide_phrase_list": "Hide Phrase List",
  "move_phrase_list": "Move Phrase List",
  "remove_phrase_list": "Remove Phrase List",
  "show_exercise": "Show Exercise",
  "hide_keyboard": "Hide Keyboard",
  "editor": "Editor",
  "phrase_list_name": "Phrase List Name",
  "phrase_list_information": "Phrase List Information",
  "build_meaning": "Build Meaning",
  "read_and_write": "Read & Write",
  "meaning_listen_and_speak": "Listen & Speak",
  "hide_phrases_exercise": "Hide Phrases",
  "show_phrases_ecercise": "Show Phrases",
  "generate_defintions_error": "Tharla fadhb agus na sainmhínithe á nginiúint. Bain triail eile as.",
  "saving_defintions_error": "Tharla fadhb agus na sainmhínithe á sábháil. Bain triail eile as.",
  "auto_generate_definitions": "Sainmhínithe a Ghiniúint",
  "generating_definitions": "Sainmhínithe á nginiúint",
  "definitions": "Sainmhínithe",
  "view_phrase_list": "Féach ar liosta na bhfrásaí",
  "meaning_exercise_welcome": "Welcome to the Meaning Exercise",
  "meaning_exercise_definition": "Definition",
  "meaning_exercise_definition_desc": "Select the correct word or phrase based on the definition",
  "meaning_exercise_options": "Options",
  "meaning_exercise_options_desc": "Select the correct options for this sentence",
  "meaning_no_definitions": "This phrase list has no definitions",
  "definition": "Definition",
  "review_generated_definitions": "Review Generated Definitions",
  "new_definitions": "New Definition",
  "current_definitions": "Current Definition",
  "play_phrase_list": "Play Phrase List",
  "transfer_phrases": "Cóipeáil go",
  "transfer": "Cóipeáil",
  "create_phrase_list_from_selection": "Cruthaigh Liosta Frásaí Nua",
  "no_other_phrase_lists": "Níl aon liosta frásaí eile ann",
  "add_row": "Cuir ró leis",
  "problem_updating": "Bhí fadhb le nuashonrú",
  "exercise_settings": "Socruithe cleachtadh",
  "excercise_voice": "Guth cleachtaidh",
  "excercise_voice_desc": "Roghnaigh an guth a úsáidfear i gcleachtaí don liosta frásaí seo.",
  "excercise_visibility": "Infheictheacht cleachtaidh",
  "keyboard": "Méarchlár",
  "legacy_voice_tooltip_text": "Older voice technology. May sound less natural.",
  "listen_and_speak_exercise_desc": "Listen to the definition. Say the phrase.",
  "identify_this_phrase": "Identify this phrase",
  "play_phrase": "Play Phrase",
  "listen_and_speak_exercise_welcome": "Getting started with the Listen & Speak Exercise",
  "listen_and_speak_exercise_speak_desc": "Click to listen to how the definition",
  "listen_and_speak_exercise_listen": "Listen to the definition!",
  "listen_and_speak_exercise_voice_input": "Pronounce the phrase that matches the definition",
  "hide_phrase_image": "Hide phrase image",
  "show_phrase_image": "Show phrase image",
  "read_write_exercise_welcome": "Fáilte go dtí an tSaothrach Léigh & Scríobh",
  "read_write_exercise_definition": "Sainmhíniú",
  "read_write_exercise_definition_desc": "Léigh an sainmhíniú a thaispeántar anseo",
  "read_write_exercise_options": "Clóscríobh an Frása",
  "read_write_exercise_options_desc": "Clóscríobh an frása ceart sa bhosca téacs",
  "read_the_definition": "Léigh an sainmhíniú",
  "type_the_correct_phrase": "Clóscríobh an frása ceart",
  "read_write": "Léigh & Scríobh",
  "meaning_read_write": "Ciall - Léigh & Scríobh",
  "meaning_read_write_exercise_desc": "Léigh an sainmhíniú agus clóscríobh an frása ceart.",
  "course_description_default": "This is a course to help students speak {{learnLang}} with confidence.",
  "image_builder": "Image Builder",
  "background_color": "Background Color",
  "icon": "Icon",
  "pattern_density": "Pattern Density",
  "use_image": "Use Image",
  "background_colour": "Background Colour",
  "icon_opacity": "Icon Opacity",
  "custom_colour": "Custom Colour",
  "create_chatbot": "Cruthaigh chatbot",
  "find_chatbot": "Aimsigh chatbot",
  "find_chatbots": "Aimsigh chatbots",
  "add_chatbot": "Cuir chatbot leis",
  "add_chatbots": "Cuir chatbots leis",
  "template": "Teimpléad",
  "chatbot_name": "Ainm an chatbot",
  "create_scenario": "Cruthaigh rólghlacadh",
  "find_scenario": "Aimsigh rólghlacadh",
  "find_scenarios": "Aimsigh rólghlacthaí",
  "scenario_name": "Ainm an rólghlacadh",
  "scenarios_added": "Rólghlacthaí curtha leis an ábhar",
  "chatbots_added": "Chatbots curtha leis an ábhar",
  "add_scenarios": "Cuir rólghlacthaí leis",
  "achievements": "Achievements",
  "topic_description_default": "This is a topic to help students speak {{learnLang}} with confidence.",
  "selected_topics": "Selected Topics",
  "no_topics_selected": "No topics selected",
  "add_topics": "Add topics",
  "find_topics": "Find topics",
  "find_topic": "Find Topic",
  "no_topics_found": "No topics found",
  "no_library_topics_community_hint": "Aimsigh ábhair a chruthaigh múinteoirí eile sa chluaisín <1>Pobal</1>.",
  "chatbot_title": "Teideal an chatbot",
  "open_ended": "Críochnaithe Oscailte",
  "open_ended_desc": "Lig do dhaltaí freagairt ina bhfocail féin.",
  "quiz": "Tráth na gCeist",
  "quiz_desc": "Treoraigh an dalta trí shraith ceisteanna.",
  "picture_quiz": "Tráth na gCeist Pictiúr",
  "picture_quiz_desc": "Cuir ceisteanna bunaithe ar phictiúir.",
  "emoji_quiz": "Tráth na gCeist Emoji",
  "emoji_quiz_desc": "Buille faoi thuairim an freagra bunaithe ar na emojis.",
  "quiz_style_templates": "Teimpléid i stíl tráth na gceist",
  "no_scenarios_found": "Níl aon rólghlacthaí ann",
  "no_chatbots_found": "Níl aon chatbots ann",
  "use_voice": "Úsáid Guth",
  "internal_view_provider_marks": "Amharc Inmheánach · Marcanna an tSoláthraí le Feiceáil",
  "legacy": "Oidhreacht",
  "scan_to_open_the_classroom": "Scan chun an seomra ranga a oscailt",
  "classroom_link": "Nasc an tseomra ranga",
  "copy": "Cóipeáil",
  "tell_students_to": "Abair leis na mic léinn",
  "invite_step_sign_in": "Logáil isteach ina gcuntas.",
  "invite_step_scan": "Scan an cód, nó oscail an seomra ranga.",
  "invite_step_tap_join": "Tapáil {{button}}.",
  "select_exercise_phrases_intro": "Roghnaigh na liostaí frásaí ar mhaith leat imirt leo. Is féidir leat liostaí ó chúrsaí éagsúla a mheascadh.",
  "select_exercise_scenarios_intro": "Roghnaigh cás le himirt beo leis an rang.",
  "source_type_phrase_lists": "Liostaí frásaí",
  "source_type_scenarios": "Cásanna",
  "clear_all": "Glan Uile",
  "n_of_m_lists_selected": "{{n}} as {{m}} liosta roghnaithe",
  "n_phrase_lists": "{{count}} liosta frásaí",
  "n_phrases": "{{count}} frása",
  "has_definitions": "sainmhínithe ann",
  "n_scenarios": "{{count}} cás",
  "n_messages": "{{count}} teachtaireacht",
  "n_interactions": "{{count}} idirghníomhaíocht",
  "lists_and_phrases_selected": "{{lists}} liosta · {{phrases}} frása",
  "no_lists_selected": "Níl aon liosta roghnaithe",
  "no_scenario_selected": "Níl aon chás roghnaithe",
  "scenario_selected": "Cás roghnaithe",
  "number_of_messages": "Líon na dteachtaireachtaí",
  "max_phrases_label": "Uas",
  "max_phrases_all": "Gach {{count}}",
  "estimated_game_time_hint": "{{questions}} ceist ag {{seconds}}s an ceann, móide aiseolas idir bhabhtaí.",
  "n_minutes": "{{count}} nóiméad",
  "live_game_title": "{{exercise}} · {{count}} liosta frásaí",
  "phrases_from": "Frásaí ó",
  "source_card_meta": "{{topic}} · {{count}} frása",
  "n_more": "eile",
  "waiting_for_students": "Ag fanacht le mic léinn páirt a ghlacadh.",
  "how_students_answer": "Conas a fhreagraíonn mic léinn",
  "answer_keyboard_and_word_bank": "Méarchlár agus banc focal",
  "answer_keyboard_and_word_bank_hint": "Clóscríobhann mic léinn, le tíleanna focal mar chúltaca.",
  "answer_keyboard_only": "Méarchlár amháin",
  "answer_keyboard_only_hint": "Is deacra — clóscríobhann mic léinn an freagra ar fad.",
  "answer_word_bank_only": "Banc focal amháin",
  "answer_word_bank_only_hint": "Is éasca — tapálann mic léinn focail ina n-áit.",
  "time_per_question": "Am in aghaidh na ceiste",
  "all_n_phrases": "Gach {{count}} frása",
  "includes_one_from_each_list": "Cuirtear frása amháin ar a laghad ó gach liosta roghnaithe san áireamh i gcónaí.",
  "chatbot": "Chatbot",
  "scenario": "Scenario",
  "conversation": "Conversation",
  "from_course": "From course",
  "from_course_named": "From course: {{title}}",
  "start_topic": "Start topic",
  "start_chat": "Start chat",
  "start_scenario": "Start scenario",
  "n_activities": "{{number}} activities",
  "roleplay_turns": "Roleplay · {{number}} turns",
  "filter_by_type": "Filter by type",
  "view_course_named": "View {{title}}",
  "show": "Show",
  "content_type": "Content type",
  "all_content": "all content",
  "results_summary": "{{number}} results for “{{query}}” · {{types}}",
  "n_results_named": "{{label}}, {{number}} results",
  "view_chatbot": "View chatbot",
  "view_scenario": "View scenario",
  "all_languages": "All languages",
  "all_levels": "All levels",
  "novice": "Novice",
  "intermediate": "Intermediate",
  "advanced": "Advanced",
  "popular": "Popular",
  "courses_shared_by_other_teachers": "Courses shared by other teachers",
  "no_created_courses_match": "No created courses match these filters",
  "no_joined_courses_match": "No joined courses match these filters",
  "no_community_courses_match": "No courses match these filters",
  "courses_added": "Courses added",
  "problem_adding_courses": "There was a problem adding those courses",
  "search_topics_placeholder": "Search topics",
  "search_classrooms_placeholder": "Search classrooms",
  "search_student_name": "Search student name",
  "search_sections_and_topics": "Cuardaigh rannóga agus topaicí",
  "clear_search": "Glan an cuardach",
  "x_of_y": "{{shown}} as {{total}}",
  "outline_filter_count": "{{topics}} i {{sections}}",
  "topic_count_one": "{{count}} topaic",
  "topic_count_other": "{{count}} topaicí",
  "section_count_one": "{{count}} rannóg",
  "section_count_other": "{{count}} rannóga",
  "no_sections_or_topics_match": "Níl aon rannóg ná topaic ag teacht leis",
  "try_different_keyword_or_difficulty": "Bain triail as eochairfhocal nó deacracht eile.",
  "nothing_matches_keyword_at_difficulty": "Níl aon rud ag teacht le “{{keyword}}” ag deacracht {{difficulty}}. Bain triail as eochairfhocal nó deacracht eile.",
  "session_feedback": "D'aiseolas",
  "session_feedback_preparing": "Ag ullmhú d'aiseolais…",
  "session_feedback_unavailable": "Níl d'aiseolas ar fáil faoi láthair.",
  "suggested_level": "Leibhéal molta",
  "session_report": "Aiseolas ar an gcomhrá",
  "view_full_report": "Féach ar an aiseolas iomlán",
  "rating_approaching": "Ag druidim",
  "rating_meets": "Comhlíonann",
  "rating_exceeds": "Sáraíonn",
  "area_of_strength": "Láidreacht",
  "area_for_growth": "Réimse forbartha",
  "rating_not_yet": "Níl fós",
  "session_report_short_interaction": "Idirghníomhú",
  "session_report_short_vocabulary": "Foclóir",
  "session_report_short_function": "Feidhm",
  "session_report_strength": "Láidreacht",
  "session_report_growth": "Forbairt",
  "ai_generated_report": "Aiseolas ginte ag IS",
  "ai_generated_report_tooltip": "Ginte ag IS ón seisiún seo amháin. Is meastacháin iad an leibhéal molta agus na rátálacha, ní socrúchán deiridh.",
  "session_report_new": "Nua",
  "chatbot_mode_name": "Chatbot - {{mode}}",
  "chatbot_message_count": "{{count}} teachtaireacht",
  "chatbot_message_count_one": "{{count}} teachtaireacht",
  "chatbot_message_count_other": "{{count}} teachtaireacht",
  "attempt_count": "{{count}} iarracht",
  "attempt_count_one": "{{count}} iarracht",
  "attempt_count_other": "{{count}} iarracht",
  "of_total_correct": "as {{total}} ceart",
  "attempts_to_review": "Iarrachtaí le hathbhreithniú",
  "attempts_not_shown": "{{items, list}}: iarrachtaí nach dtaispeántar",
  "count_correct": "{{count}} ceart",
  "count_incorrect": "{{count}} mícheart",
  "count_skipped": "{{count}} scipeáilte",
  "count_partially_correct": "{{count}} ceart go páirteach",
  "view_all_count": "Féach ar gach ceann ({{count}})",
  "view_attempt": "Féach ar an iarracht",
  "scenario_description_default": "Is cás é seo chun cabhrú le scoláirí {{learnLang}} a labhairt go muiníneach."
}
